import { Component, ViewChild, Inject, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from "@angular/router";
import { Title } from '@angular/platform-browser';
import { BookingService } from "../service/booking.service";
import { BookingDataModel, UserData, BookingDoctorDataContainer, GeneralBookingModel, SlotBookingModel, DepartmentDataModel, PaymentDetails, keyvaluepair, Bookingkeyvaluepair, requestParam, responseParam} from "../../model/index"
import { IMyDpOptions, IMyDateModel } from 'mydatepicker';
import { IonRangeSliderComponent } from "ng2-ion-range-slider";
import { ModalComponent } from "../../shared/modeldialog/index";
import { SecurityService } from '../../Security/security.service';
import { CurrencyDetails } from "../../model/utilities/currencydetails";
import { FileToUpload } from "../../model/Documents/FileToUpload";

declare let jspdf: any;
declare let html2canvas: any;

declare var bookingGrid: any;
declare let Checkout: any;
declare var require: any;
declare let MaxWallet: any;
declare let CryptoJS: any;

@Component({
    selector: 'MentisSoft-Booking',
    template: require('../Template/Booking.template.html'),
    styles: [require('../Template/Booking.css')],
    providers: [CurrencyDetails]
})

export class BookingComponent implements OnInit {
    @ViewChild("viewModelPopup") viewModelPopup: ModalComponent;
    @ViewChild("slotAllotment") slotAllotment: ModalComponent;
    @ViewChild("paylaterPopup") paylaterPopup: ModalComponent;
    @ViewChild("BookingConfirmed") BookingConfirmed: ModalComponent;
    @ViewChild("EmailAlertpopup") EmailAlertpopup: ModalComponent;
    @ViewChild('advancedSliderElement') advancedSliderElement: IonRangeSliderComponent;
    @ViewChild("Alertpayment") Alertpayment: ModalComponent;
    @ViewChild("BookingDoctorOnline") BookingDoctorOnline: ModalComponent;
    @ViewChild("IsPatientValid") IsPatientValid: ModalComponent;
    @ViewChild("BookingConfirmedPayment") BookingConfirmedPayment: ModalComponent;
    @ViewChild("PopupPayment") PopupPayment: ModalComponent;
    @ViewChild("openTermConditions") openTermConditions: ModalComponent;
    @ViewChild("AlertBookPopup") AlertBookPopup: ModalComponent;
    @ViewChild("PrintPreviewpopup") PrintPreviewpopup: ModalComponent;
    depts: DepartmentDataModel[] = [];
    myDatePickerOptions: IMyDpOptions = {
        dateFormat: 'dd/mm/yyyy',
    };

    Locs = [];
    slotBookingFailed: boolean = false;
    slotMessage: string = "If a slot is chosen, please make payment within 5 minutes else the slot will remain unbooked."
    message: string = "";
    selectedSlotDrCode: string;
    timeSlotsArray: Bookingkeyvaluepair[] = [];
    isValid = true;
    IsConfirmPay: boolean = false;

    loading = false;
    chosenSlotValue: number;
    generalBooking: GeneralBookingModel = new GeneralBookingModel();
    IsBookingConfirmed: boolean;
    payment: PaymentDetails[] = [];
    Redirect: string[] = [];
    redirectString: string;
    Querynumber: string;
    QueryIsPayment: string;
    CurrencyValue: string;
    NegativeConsultationCharge: boolean = false;
    TokenNegativeConsultationCharge: boolean = false;
    selectedSlotClass: string;
    inProgressSlot: string;
    scheduledStartTime: string;
    scheduledEndTime: string;
    enableJnhPopup: string;
    enableHadiPopup: string;
    DoctorsSlotTiming: string;
    BookingType: string = "";
    PaymentGatewayType: string = "";
    payLaterStatus: string = "";
    paylaterBookingStatus: boolean = false;
    isSlotValueChosen: boolean = false;
    slotErrorMessage: string = "NO";
    enableSaving: string = "YES";
    patientSex: string = "";
    patientAge: number;
    emailMsg: string = "";
    IsAdminUser: boolean = false;
    patientId: string = "";
    patientName: string = "";
    IsPatientSearch: boolean = false;
    errMsg: string = "";
    IsAlertBookPopup: boolean = false;  
    TermsChecked: boolean = false;
    IsBookingDoctorOnline: boolean = false;
    checkcontrolbook: boolean = false;
    appointmentBooking: boolean = false;
    MobileNoValid1: boolean = false;
    PaymentType: string = "";
    IsSelectEmailValidation: boolean = false;
    IsPopupPayment: boolean = false;
    IsGuestEmailReq: boolean = false;
    CPRNOlength: string = "";
    mobilePlaceHolder: string = "";
    IsSelectEmailRed: boolean = false;
    IsPatientOBGYN: boolean = false;
    IsPatientValidFailed: boolean = false;
    IsPatientPediatric: boolean = false;
    SearchMobileNumber: string = "";
    SelecterrMsg1: string = "";
    IsselectPatientSearch1: boolean = false;
    IsSearchMobileNumberRed: boolean = false;
    IsTransaction: boolean = true;
    IsHelpLineNo: boolean = true;
    IsTokenNo: boolean = true;
    PayedDeptName: string = "";
    PayedDoctorName: string = "";
    PayedPayAmount: string = "";
    PayedSlot: string = "";
    Printurl: string = "";
    transactionNo: string = "";
    AppointmentNo: string = "";
    ReceiptNo: string = "";
    PatientId: string = "";
    AppointmentDate: string = "";
    IsBookingConfirmedPayment: boolean = false;
    isValidPayment: boolean = false;
    PaymentErroMsg: string = "";
    Cancelurl: string = "";
    QueryResult: string;
    HelpLineNo: string = "";
    JnhFirstSlot: string = "";
    TokenNo: string = "";
    doctorName: string = "";
    NativeDeptName: string = "";
    NativeDoctorName: string = "";
    IsEnglish: boolean = true;
    PrintPatientName: string = "";
    InstructionEng: string = "";
    InstructionArabic: string = "";
    CPRNONumber: string = "";
    ClinicName: string = "";
    CompanyPostBox: string = "";
    CompanyAddress: string = "";
    CompanyPhoneNumber: string = "";
    CompanyFax: string = "";
    CompanyEmail: string = "";
    CompanyLinkEmail: string = "";
    trackid: string = "";
    ISSelfPayOption: string = "TRUE";
    AppNumber: string = "";
    previousUrl: string;
    ScheduleDeptNumber: string = "";
    ScheduleAppNumber: string = "";
    IsDepartShow: boolean = true;
    SlotVisible: boolean = true;
    IsProceedPayNow: string = "";
    IsProceedPaybutton: boolean = true;
    HospitalName: string = "";
    CivilORCPRName: string = "Civil Id/CPR No";

    IsDocumentAttached: boolean = false;
    IsValidationCivil: boolean = false;
    IsValidationPassport: boolean = false;
    IsValidationeVisa: boolean = false;
    IsValidationMOH: boolean = false;
    IsValidationDocument: boolean = false;
    ISReqDocOption: boolean = false;
    ISDocDepartOption: string = "";
    IsUploadDocVisble: boolean = false;
    IsUploadFailmsg: boolean = false;
    UploadFailmsg: string = "";
    ValidateCivil: boolean = false;
    IsuploadValidationErrorMsg: boolean = false;
    UploadValidationErrorMsg: string = "";
    IsCivilFrontImage: boolean = false;
    IsCivilBackImage: boolean = false;
    IsPassportFrontImage: boolean = false;
    IsPassportBackImage: boolean = false;
    IsVisaImage: boolean = false;
    IsMOHImage: boolean = false;
    IsReqCivil: boolean = false;
    IsCivilRed: boolean = false;

    fileList: string[] = [];
    MAX_SIZE: number = 5048576;
    theFile: any = null;
    messages: string[] = [];
    errormessage: string = "";

    IsLocationVisible: boolean = false;
    IsLocationChange: boolean = false;
    requestparamater: requestParam = new requestParam();
	tapQuerynumber:string;
    ngOnInit() {
        this.IsAdminUser = JSON.parse(localStorage.getItem("ISAdmin"));
        if (localStorage.getItem("HospitalName").toUpperCase() == "BSH" || localStorage.getItem("HospitalName").toUpperCase() == "DEMO") {
            this.IsLocationVisible = true;
            this.LoadLocation();
        }
        this.LoadDepartments();
    }

    ngAfterViewInit(): void {
        this.IsAdminUser = JSON.parse(localStorage.getItem("ISAdmin"));
        if (this.IsAdminUser == true) {
            if (localStorage.getItem("AdminPatientId") != undefined || localStorage.getItem("AdminPatientId") != null)
                this.patientId = localStorage.getItem("AdminPatientId");
            if (localStorage.getItem("AdminPatientName") != undefined || localStorage.getItem("AdminPatientName") != null)
                this.patientName = localStorage.getItem("AdminPatientName");
            if (this.patientName == "null")
                this.patientName = "";
        }
        $('#overlay').hide();
        this._titleService.setTitle("Bookings");
        this.BookingType = localStorage.getItem("BookingType");
        this.HospitalName = localStorage.getItem("HospitalName");
        if (this.HospitalName == "JNH") {
            this.appDate = { date: { year: this.year.getFullYear(), month: this.year.getMonth() + 1, day: this.year.getDate() + 1 } };//{ date: { year: this.year.getFullYear(), month: this.year.getMonth() + 1, day: this.year.getDate() + 1 } };
            this.activebutton = this.year.getDay() + 1;
            this.date = ("0" + (this.year.getDate() + 1)).slice(-2) + "/" + this.month + "/" + this.year.getFullYear();
            this.myDatePickerOptions = {
                disableUntil: { year: this.year.getFullYear(), month: this.year.getMonth() + 1, day: this.year.getDate() },

            };
        }
        if (localStorage.getItem("HospitalName").toUpperCase() == "BSH") {
            this.CivilORCPRName = "CPR No";
        }
        this.LoadBookingReports();
        if (this.Querynumber == "Reschedule" || this.QueryResult == "Reschedule") {
            this.IsDepartShow = false;
            this.LoadDepartments();
        }
        else {
            if (this.Querynumber != "" && this.Querynumber != undefined && this.QueryResult == "CAPTURED") {
                this.generalBooking.CaptureData = "CAPTURED";
                this.LoadingAfterPayment(this.Querynumber);
            }
            if (this.Querynumber != "" && this.Querynumber != undefined) {
                if (this.QueryResult != "CAPTURED" && this.QueryResult != "" && this.QueryResult != undefined) {
                    this.generalBooking.CaptureData = this.QueryResult;
                    this.LoadingAfterPayment(this.QueryResult);
                }
                else {
                    if (this.QueryResult == "" || this.QueryResult == undefined) {
                        this.generalBooking.CaptureData = this.QueryResult;
                        this.LoadingAfterPayment(this.Querynumber);
                    }
                }
            }
            if (this.Querynumber == undefined && this.Cancelurl != "" && this.Cancelurl != undefined && this.Cancelurl == "__hc-action-cancel") {
                this.generalBooking.CaptureData = "CANCEL";
                this.LoadingAfterPayment("CANCEL");
            }
            if (this.Querynumber == "" && this.QueryResult == "") {
                this.generalBooking.CaptureData = "DENIED+BY+RISK";
                this.LoadingAfterPayment("DENIED+BY+RISK");
            }
			if (this.tapQuerynumber != "" && this.tapQuerynumber != undefined) {
            this.generalBooking.CaptureData = "TAPPAY";
            //if (this.generalBooking.CaptureData == "CAPTURED")
            //    this.Alertpayment.open();
            this.LoadingAfterPayment("TAPPAY");
        }
        }
    }

    constructor( @Inject(SecurityService) private _SecurityService: SecurityService, private router: Router, private activatedRoute: ActivatedRoute, private _bookingService: BookingService, private _titleService: Title,
        @Inject(CurrencyDetails) private _CurrencyDetails: CurrencyDetails) {
        bookingGrid = this;
        this.bookingFilter = new BookingDataModel();
        this.bookingFilter.DEPT_CODE = "0";
        this.QueryResult = router.parseUrl(router.url).queryParams["result"];
        if (this.QueryResult == "Reschedule") {
            this.generalBooking.ISReschedule = this.QueryResult;
            this.Querynumber = router.parseUrl(router.url).queryParams["Id"];
            this.generalBooking.ReScheduleDeptNumber = this.Querynumber;
			this.tapQuerynumber = router.parseUrl(router.url).queryParams["tap_id"];
			 this.generalBooking.Tap_id = this.tapQuerynumber;
            this.AppNumber = router.parseUrl(router.url).queryParams["AppNumber"];
            this.generalBooking.ReScheduleAppNumber = this.AppNumber;
        }
        else {           
            this.Cancelurl = router.parseUrl(router.url).fragment;
            this.Querynumber = router.parseUrl(router.url).queryParams["Id"];
            this.generalBooking.AppReqPatientId = this.Querynumber;
			this.tapQuerynumber = router.parseUrl(router.url).queryParams["tap_id"];
			 this.generalBooking.Tap_id = this.tapQuerynumber;
            this.AppNumber = router.parseUrl(router.url).queryParams["AppNumber"];
            this.generalBooking.AppointmentRquestNo = this.AppNumber;
            this.QueryResult = router.parseUrl(router.url).queryParams["result"];
            if (this.Querynumber == "" || this.Querynumber == undefined) {
                this.Querynumber = this.router.parseUrl(this.router.url).queryParams["result"];
            }
        }
    }

    year = new Date();
    appDate: Object = { date: { year: this.year.getFullYear(), month: this.year.getMonth() + 1, day: this.year.getDate() } };
    appDate1: Object = { date: { year: this.year.getFullYear(), month: this.year.getMonth() + 1, day: this.year.getDate() } };
    workingDays: any = [{ val: 9, day: "Any" }, { val: 1, day: "Mon" }, { val: 2, day: "Tue" }, { val: 3, day: "Wed" }, { val: 4, day: "Thu" }, { val: 5, day: "Fri" }, { val: 6, day: "Sat" }, { val: 7, day: "Sun" }];

    dataSource: BookingDataModel[] = [];
    bookingFilter: BookingDataModel;
    dataSourceOriginal: BookingDataModel[] = [];

    columns: any[] = [];
    month = ("0" + (this.year.getMonth() + 1)).slice(-2);
    date: string = ("0" + this.year.getDate()).slice(-2) + "/" + this.month + "/" + this.year.getFullYear();
    data: BookingDoctorDataContainer;
    clickedDate: string;
    advancedSlider = { name: "Advanced Slider", onUpdate: undefined, onFinish: undefined };
    activeTab: number = 9;
    activebutton: number = this.year.getDay();
    activebutton1: number = this.year.getDay();
    update(slider, event) {
        slider.onUpdate = event;
    }

    finish(slider, event) {
        slider.onFinish = event;
        if (event) {
            this.bookingFilter.FromTime = event.from + ":00";
            this.bookingFilter.ToTime = event.to + ":00";
            this.LoadFilterReports();
        }
    }

    setTab(val: number) {
        if (val != 9) {
            var d = new Date();
            if (d.getDay() > val) {
                d.setDate(d.getDate() + (7 - d.getDay()) + val)
            }
            else {
                d.setDate(d.getDate() + (val - d.getDay()));
            }
            this.appDate = { date: { year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate() } };
            //this.appDate1 = { date: { year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate() } };
            this.activebutton = val;
            this.activebutton1 = val;
            this.clickedDate = ("0" + d.getDate()).slice(-2) + "/" + ("0" + (d.getMonth() + 1)).slice(-2) + "/" + d.getFullYear();
            this.bookingFilter.FromDate = this.clickedDate;
            this.date = this.bookingFilter.FromDate;
            this.bookingFilter.DAYS = val.toString();

        }
        else {
            this.appDate = { date: { year: this.year.getFullYear(), month: this.year.getMonth() + 1, day: this.year.getDate() } };
            this.activebutton = val;
            this.bookingFilter.FromDate = this.date;
        }
        this.LoadFilterReports();

    }

    setTab1(val: number) {
        this.SlotVisible = false;
        if (val != 9) {
            var d = new Date();
            if (d.getDay() > val) {
                d.setDate(d.getDate() + (7 - d.getDay()) + val)
            }
            else {
                d.setDate(d.getDate() + (val - d.getDay()));
            }
            this.appDate1 = { date: { year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate() } };
            this.activebutton1 = val;
            this.clickedDate = ("0" + d.getDate()).slice(-2) + "/" + ("0" + (d.getMonth() + 1)).slice(-2) + "/" + d.getFullYear();
            this.bookingFilter.FromDate = this.clickedDate;
            this.date = this.bookingFilter.FromDate;
            this.bookingFilter.DAYS = val.toString();

        }

        else {
            this.appDate1 = { date: { year: this.year.getFullYear(), month: this.year.getMonth() + 1, day: this.year.getDate() } };
            this.activebutton1 = val;
        }
        // this.LoadFilterReports();
        this.showBookingSlots1(this.generalBooking.doctorId);

    }
    isActive(val: number, val1: number): boolean {
        if (val1 == val)
            return true
        return false;
    }

    showBookingSlots1(drCode) {
        this.SlotVisible = true;
        var userData: UserData = new UserData("0", "", "", false);
        this.loading = true;
        this.timeSlotsArray = [];
        /* this.selectedSlotClass = "";
       this.selectedSlotDrCode = drCode;
       this.TermsChecked = false;
       this.clearPatientValues();
       this.isSlotValueChosen = false;
       this.slotErrorMessage = "NO"
       this.IsPatientcountone = false;
       this.IsMobileText = false;
       this.generalBooking.consultationFee = "0";
       if (this.ISSelfPayOption == "TRUE") {
           this.AlertBookPopup.open();
           this.IsAlertBookPopup = true;
       }

       var userData: UserData = new UserData("0", "", "", false);
       for (var i = 0; i < this.dataSource.length; i++) {
           if (this.dataSource[i].DoctorCode == drCode) {*/
        if (this.bookingFilter.FromDate == undefined) {
            this.bookingFilter.FromDate = this.date;
        }
        if (this.bookingFilter.ToTime == undefined) {
            this.bookingFilter.ToTime = "23";
        }
        if (this.bookingFilter.FromTime == undefined) {
            this.bookingFilter.FromTime = "00";
        }
        this.generalBooking.date = this.bookingFilter.FromDate;
        this.generalBooking.dayCode = this.activebutton1;
        /*this.generalBooking.department = this.dataSource[i].DeptName;
        this.generalBooking.departmentIdofChosenDoctor = this.dataSource[i].DEPT_CODE;
        this.generalBooking.SLOT = this.dataSource[i].SLOT;
        this.generalBooking.doctorId = this.dataSource[i].DoctorCode;
        this.generalBooking.doctorName = this.dataSource[i].DoctorName;
        this.generalBooking.NativeDoctorName = this.dataSource[i].NativeDoctorName;
        this.generalBooking.NativeDeptName = this.dataSource[i].NativeDeptName;
        this.generalBooking.DisplayOrder = Number(this.dataSource[i].DisplayOrder);
        this.generalBooking.IS_BOOK_ALLOW = this.dataSource[i].IS_BOOK_ALLOW
        this.generalBooking.Id = "0";
        this.generalBooking.speciality = this.dataSource[i].Speciality;
        this.generalBooking.scheduledEndTime = this.bookingFilter.ToTime;
        this.generalBooking.scheduledStartTime = this.bookingFilter.FromTime;
        this.generalBooking.token = this.dataSource[i].Token;
        this.generalBooking.dayCode = this.activebutton;
        this.generalBooking.ImageByte = "";
        this.generalBooking.ImageByte = this.dataSource[i].ImageByte;
        this.generalBooking.SlotPeriod = this.dataSource[i].SlotPeriod;
        this.generalBooking.StartTime = this.dataSource[i].StartTime;
        this.generalBooking.EndTime = this.dataSource[i].EndTime;
        this.generalBooking.SessionCode = this.dataSource[i].SessionCode;
        this.generalBooking.CLINIC_CODE = this.dataSource[i].CLINIC_CODE;
        this.scheduledEndTime = this.dataSource[i].EndTime.toString().split('T')[1].slice(0, 5);
        this.scheduledStartTime = this.dataSource[i].StartTime.toString().split('T')[1].slice(0, 5);
        this.DoctorsSlotTiming = this.dataSource[i].DoctorTime;
    }
}*/
localStorage.setItem("SelectDeptId", this.generalBooking.departmentIdofChosenDoctor);
        localStorage.setItem("SelectDate", this.generalBooking.date);
        localStorage.setItem("SelectDay", this.generalBooking.dayCode.toString());
        this._bookingService.getConfirmBookingStatusGuest(this.generalBooking, userData)
            .subscribe(
                p => {
                    this.loading = false;
                    if (p.SessionExpiry) {
                        this._SecurityService.errorMessage = "";
                        if (p.doctorStatus == "YES") {
                            this.generalBooking.totalTimeSlots = p.totalTimeSlots;
                            this.DoctorsSlotTiming = p.DoctorSlot;
                            this.generalBooking.SLOT = p.Totalslot;

                            if (p.consultationChargesMessage == "") {
                                this.generalBooking.consultationFee = p.consultationFee;
								this.generalBooking.NO_CHARGE = p.NO_CHARGE;
                                this.IsConfirmPay = true;
                            }
                            else {
                                this.generalBooking.consultationFee = "0.00";
                                this.IsConfirmPay = false;
                            }

                            if (this.IsConfirmPay == true)
                                this.payLaterStatus = p.PaymentLaterStatus;
                            else
                                this.payLaterStatus = "TRUE";

                            if (this.BookingType == "SLOT") {

                                this.GetSplittedTimeSlots(this.generalBooking.totalTimeSlots, drCode);
                                if (this.ISSelfPayOption == "TRUE") {
                                }
                                else {
                                    if (this.DoctorsSlotTiming != null && this.DoctorsSlotTiming != "" && this.DoctorsSlotTiming != undefined) {
                                        this.viewModelPopup.open();
                                        this.enableHadiPopup = "YES";
                                    }
                                    else {
                                        this.IsPatientValidFailed = true;
                                        this.IsPatientValid.open();
                                        this.message = "No available slot for the selected date. Choose another date";
                                    }
                                }
                            }
                            else {
                                this.GetSplittedTimeSlots(this.generalBooking.totalTimeSlots, drCode);
                                if (this.ISSelfPayOption == "TRUE") {
                                }
                                else {
                                    if (this.DoctorsSlotTiming != null && this.DoctorsSlotTiming != "" && this.DoctorsSlotTiming != undefined) {
                                        this.viewModelPopup.open();
                                        this.enableJnhPopup = "YES";
                                    }
                                    else {
                                        this.IsPatientValidFailed = true;
                                        this.IsPatientValid.open();
                                        this.message = "No available Token for the selected date. Choose another date";
                                    }
                                }
                            }
                            this.generalBooking.ServiceCode = p.ServiceCode;
                            this.isValid = true;
                        }
                        else {
                            this.isValid = false;
                        }
                    }

                    else if (!p.SessionExpiry) {
                        this._SecurityService.errorMessage = "Your session has expired. Please login again.";
                        this.router.navigate(["/Login"]);
                    }
                },
                err => {
                    this.loading = false;
                    console.log("Error while getting data...");
                });
    }

    showBookingSlots(drCode) {
        this.SlotVisible = true;
        this.loading = true;
        this.appDate1 = this.appDate;
        if (this.IsAdminUser == true) { 
            this.IsPatientSearch == false;
            this.slotErrorMessage = "NO";
            this.isSlotValueChosen = false;
            this.timeSlotsArray = [];
            this.selectedSlotClass = "";
            this.selectedSlotDrCode = drCode;
            
            this.CurrencyValue = localStorage.getItem("CurrencySymbol");
            if (this.ISSelfPayOption == "TRUE") {
                this.AlertBookPopup.open();
                this.IsAlertBookPopup = true;
            }
            var userData: UserData = new UserData(this._SecurityService.pid, this._SecurityService.authentication, this.patientId, this._SecurityService.IsAdminUser);
            for (var i = 0; i < this.dataSource.length; i++) {
                if (this.dataSource[i].DoctorCode == drCode) {
                    if (this.bookingFilter.FromDate == undefined) {
                        this.bookingFilter.FromDate = this.date;
                    }
                    if (this.bookingFilter.ToTime == undefined) {
                        this.bookingFilter.ToTime = "17:00";
                    }
                    if (this.bookingFilter.FromTime == undefined) {
                        this.bookingFilter.FromTime = "09:00";
                    }
                    this.generalBooking.date = this.bookingFilter.FromDate;
                    this.generalBooking.department = this.dataSource[i].DeptName;
                    this.generalBooking.departmentId = this.dataSource[i].DEPT_CODE;
                    this.generalBooking.doctorId = this.dataSource[i].DoctorCode;
                    this.generalBooking.SLOT = this.dataSource[i].SLOT;
                    this.generalBooking.doctorName = this.dataSource[i].DoctorName;
                    this.generalBooking.NativeDoctorName= this.dataSource[i].NativeDoctorName;
                    this.generalBooking.NativeDeptName= this.dataSource[i].NativeDeptName;
                    this.generalBooking.DisplayOrder = Number(this.dataSource[i].DisplayOrder);
                    this.generalBooking.IS_BOOK_ALLOW = this.dataSource[i].IS_BOOK_ALLOW
                    this.generalBooking.Id = this.patientId;  
                    this.generalBooking.speciality = this.dataSource[i].Speciality;
                    this.generalBooking.scheduledEndTime = this.bookingFilter.ToTime;
                    this.generalBooking.scheduledStartTime = this.bookingFilter.FromTime;
                    this.generalBooking.dayCode = this.activebutton;
                    this.generalBooking.ImageByte = this.dataSource[i].ImageByte;
                    this.generalBooking.SlotPeriod = this.dataSource[i].SlotPeriod;
                    this.generalBooking.StartTime = this.dataSource[i].StartTime;
                    this.generalBooking.EndTime = this.dataSource[i].EndTime;
                    this.generalBooking.SessionCode = this.dataSource[i].SessionCode;
                    this.generalBooking.designation = this.dataSource[i].Designation;
                    this.generalBooking.Qualification = this.dataSource[i].Qualification;
                    this.generalBooking.VisitNo = this.dataSource[i].VisitNo;
                    this.generalBooking.color = this.dataSource[i].color;
                    this.generalBooking.CLINIC_CODE = this.dataSource[i].CLINIC_CODE; 
                    this.scheduledEndTime = this.dataSource[i].EndTime.toString().split('T')[1].slice(0, 5);
                    this.scheduledStartTime = this.dataSource[i].StartTime.toString().split('T')[1].slice(0, 5);
                    this.DoctorsSlotTiming = this.dataSource[i].DoctorTime;
                }
            }
            localStorage.setItem("MainDeptId", this.generalBooking.departmentIdofChosenDoctor);
            localStorage.setItem("MainDate", this.generalBooking.date);
            localStorage.setItem("MainDay", this.generalBooking.dayCode.toString());
            this._bookingService.getConfirmBookingStatus(this.generalBooking, userData)
                .subscribe(
                p => {
                    if (p != null && p.SessionExpiry && p.SessionTimeout != "Session Expired") {
                        this._SecurityService.errorMessage = "";
                        if (p.doctorStatus == "YES") {
                            this.generalBooking.totalTimeSlots = p.totalTimeSlots;

                            if (this.generalBooking.VisitNo != null && this.generalBooking.color == "red") {
                                this.generalBooking.consultationFee = p.consultationFee;
                                this.IsConfirmPay = true;
                                this.payLaterStatus = "FLASE";
                            }
                            else {
                                if (p.consultationChargesMessage == "") {
                                    this.generalBooking.consultationFee = p.consultationFee;
                                    this.IsConfirmPay = true;
                                }
                                else {
                                    this.generalBooking.consultationFee = "0.00";
                                    this.IsConfirmPay = false;
                                }   
                                this.generalBooking.ServiceCode = p.ServiceCode
                                this.generalBooking.ServiceName = p.ServiceName;
                                this.isValid = true;
                                if (this.IsConfirmPay == true)
                                    this.payLaterStatus = p.PaymentLaterStatus;
                                else
                                    this.payLaterStatus = "TRUE";
                            }

                            if (this.BookingType == "SLOT") {
                                this.GetSplittedTimeSlots(this.generalBooking.totalTimeSlots, drCode);
                                if (this.ISSelfPayOption == "TRUE") {
                                }
                                else {
                                    if (this.DoctorsSlotTiming != null && this.DoctorsSlotTiming != "" && this.DoctorsSlotTiming != undefined) {
                                        this.viewModelPopup.open();
                                        this.enableHadiPopup = "YES";
                                    }
                                    else {
                                        this.IsPatientValidFailed = true;
                                        this.IsPatientValid.open();
                                        this.message = "No available slot for the selected date. Choose another date";
                                    }
                                }
                            }
                            else {
                                this.isSlotValueChosen = true;
                                this.GetSplittedTimeSlots(this.generalBooking.totalTimeSlots, drCode);
                                if (this.ISSelfPayOption == "TRUE") {
                                }
                                else {
                                    if (this.DoctorsSlotTiming != null && this.DoctorsSlotTiming != "" && this.DoctorsSlotTiming != undefined) {
                                        this.viewModelPopup.open();
                                        this.enableJnhPopup = "YES";
                                    }
                                    else {
                                        this.IsPatientValidFailed = true;
                                        this.IsPatientValid.open();
                                        this.message = "No available Token for the selected date. Choose another date";
                                    }
                                }
                            }
                        }
                        else {
                            this.isValid = false;
                        }
                        this.loading = false;
                    }
                    else if (p.SessionExpiry || p.SessionTimeout == "Session expired") {
                        this.loading = false;
                        this._SecurityService.errorMessage = "Your session has expired. Please login again.";
                        this.router.navigate(["/Login"]);
                    }
                },
                err => {
                    this.loading = false;
                    console.log("Error while getting data...");
                });
        }
        else {
            this.slotErrorMessage = "NO";
            this.isSlotValueChosen = false;
            this.timeSlotsArray = [];
            this.selectedSlotClass = "";
            this.selectedSlotDrCode = drCode;
            this.CurrencyValue = localStorage.getItem("CurrencySymbol");
            if (this.ISSelfPayOption == "TRUE") {
                this.AlertBookPopup.open();
                this.IsAlertBookPopup = true;
            }
            var userData: UserData = new UserData(this._SecurityService.pid, this._SecurityService.authentication, this._SecurityService.pid, this._SecurityService.IsAdminUser);
            for (var i = 0; i < this.dataSource.length; i++) {
                if (this.dataSource[i].DoctorCode == drCode) {
                    if (this.bookingFilter.FromDate == undefined) {
                        this.bookingFilter.FromDate = this.date;
                    }
                    if (this.bookingFilter.ToTime == undefined) {
                        this.bookingFilter.ToTime = "17:00";
                    }
                    if (this.bookingFilter.FromTime == undefined) {
                        this.bookingFilter.FromTime = "09:00";
                    }
                    this.generalBooking.date = this.bookingFilter.FromDate;
                    this.generalBooking.department = this.dataSource[i].DeptName;
                    this.generalBooking.departmentId = this.dataSource[i].DEPT_CODE;
                    this.generalBooking.doctorId = this.dataSource[i].DoctorCode;
                    this.generalBooking.SLOT = this.dataSource[i].SLOT;
                    this.generalBooking.doctorName = this.dataSource[i].DoctorName;
                    this.generalBooking.DisplayOrder = Number(this.dataSource[i].DisplayOrder);
                    this.generalBooking.IS_BOOK_ALLOW = this.dataSource[i].IS_BOOK_ALLOW
                    this.generalBooking.Id = this._SecurityService.pid;
                    this.generalBooking.speciality = this.dataSource[i].Speciality;
                    this.generalBooking.scheduledEndTime = this.bookingFilter.ToTime;
                    this.generalBooking.scheduledStartTime = this.bookingFilter.FromTime;
                    this.generalBooking.dayCode = this.activebutton;
                    this.generalBooking.ImageByte = this.dataSource[i].ImageByte;
                    this.generalBooking.SlotPeriod = this.dataSource[i].SlotPeriod;
                    this.generalBooking.StartTime = this.dataSource[i].StartTime;
                    this.generalBooking.EndTime = this.dataSource[i].EndTime;
                    this.generalBooking.SessionCode = this.dataSource[i].SessionCode;
                    this.generalBooking.designation = this.dataSource[i].Designation;
                    this.generalBooking.Qualification = this.dataSource[i].Qualification;
                    this.generalBooking.VisitNo = this.dataSource[i].VisitNo;
                    this.generalBooking.color = this.dataSource[i].color;
                    this.generalBooking.CLINIC_CODE = this.dataSource[i].CLINIC_CODE;
                    this.scheduledEndTime = this.dataSource[i].EndTime.toString().split('T')[1].slice(0, 5);
                    this.scheduledStartTime = this.dataSource[i].StartTime.toString().split('T')[1].slice(0, 5);
                    this.DoctorsSlotTiming = this.dataSource[i].DoctorTime;
                }
            }
            this._bookingService.getConfirmBookingStatus(this.generalBooking, userData)
                .subscribe(
                p => {
                    if (p != null && p.SessionExpiry && p.SessionTimeout != "Session Expired") {
                        this._SecurityService.errorMessage = "";
                        if (p.doctorStatus == "YES") {
                            this.generalBooking.totalTimeSlots = p.totalTimeSlots;
                            if (this.generalBooking.VisitNo != null && this.generalBooking.color == "red") {
                                this.generalBooking.consultationFee = p.consultationFee;
                                this.IsConfirmPay = true;
                                this.payLaterStatus = "FLASE";
                            }
                            else {
                                if (p.consultationChargesMessage == "") {
                                    this.generalBooking.consultationFee = p.consultationFee;
                                    this.IsConfirmPay = true;
                                }
                                else {
                                    this.generalBooking.consultationFee = "0.00";
                                    this.IsConfirmPay = false;
                                }
                                this.generalBooking.ServiceCode = p.ServiceCode
                                this.generalBooking.ServiceName = p.ServiceName;
                                this.isValid = true;
                                if (this.IsConfirmPay == true)
                                    this.payLaterStatus = p.PaymentLaterStatus;
                                else
                                    this.payLaterStatus = "TRUE";
                            }

                            if (this.BookingType == "SLOT") {
                                this.GetSplittedTimeSlots(this.generalBooking.totalTimeSlots, drCode);
                                if (this.ISSelfPayOption == "TRUE") {
                                }
                                else {
                                    if (this.DoctorsSlotTiming != null && this.DoctorsSlotTiming != "" && this.DoctorsSlotTiming != undefined) {
                                    this.viewModelPopup.open();
                                        this.enableHadiPopup = "YES";
                                    }
                                    else {
                                        this.IsPatientValidFailed = true;
                                        this.IsPatientValid.open();
                                        this.message = "No available slot for the selected date. Choose another date";
                                    }
                                }
                            }
                            else {
                                this.isSlotValueChosen = true;
                                this.GetSplittedTimeSlots(this.generalBooking.totalTimeSlots, drCode);
                                if (this.ISSelfPayOption == "TRUE") {
                                }
                                else {
                                    if (this.DoctorsSlotTiming != null && this.DoctorsSlotTiming != "" && this.DoctorsSlotTiming != undefined) {
                                    this.viewModelPopup.open();
                                        this.enableJnhPopup = "YES";
                                    }
                                    else {
                                        this.IsPatientValidFailed = true;
                                        this.IsPatientValid.open();
                                        this.message = "No available Token for the selected date. Choose another date";
                                    }
                                }
                            }
                        }
                        else {
                            this.isValid = false;
                        }
                        this.loading = false;
                    }
                    else if (p.SessionExpiry || p.SessionTimeout == "Session expired") {
                        this.loading = false;
                        this._SecurityService.errorMessage = "Your session has expired. Please login again.";
                        this.router.navigate(["/Login"]);
                    }
                },
                err => {
                    this.loading = false;
                    console.log("Error while getting data...");

                });
        }

    }

    LoadingAfterPayment(Querynumber: string) {
        if (this.generalBooking.CaptureData == "CAPTURED")
            this.Alertpayment.open();
        var userData: UserData = new UserData(this._SecurityService.pid, this._SecurityService.authentication, this._SecurityService.pid, this._SecurityService.IsAdminUser);
        this._bookingService.AfterPaymentConfirmationdata(this.generalBooking, userData)
            .subscribe(
            s => {
                this.Alertpayment.close();
                this.CurrencyValue = localStorage.getItem("CurrencySymbol");
                if (s != null && s.SessionTimeout != "Session Expired") {
                    if (s.isValid == true) {
                        this.PayedDeptName = s.DeptName;
                        this.PayedDoctorName = s.DoctorName;
                        this.PayedPayAmount = s.PayAmount;
                        this.PayedSlot = s.Slot;
                        this.Printurl = s.Printurl;
                        this.transactionNo = s.transaction_id;
                        this.AppointmentNo = s.AppointmentNo;
                        this.ReceiptNo = s.ReceiptNo;
                        this.PatientId = s.PatientId;
                        this.ClinicName = s.ClinicName;
                        this.CompanyPostBox = s.CompanyPostBox;
                        this.CompanyAddress = s.CompanyAddress;
                        this.CompanyPhoneNumber = s.CompanyPhoneNumber;
                        this.CompanyFax = s.CompanyFax;
                        this.CompanyEmail = s.CompanyEmail;
                        this.CompanyLinkEmail = s.CompanyLinkEmail;
                        this.InstructionEng = s.InstructionEng;
                        this.InstructionArabic = s.InstructionArabic;

                        this.AppointmentDate = s.AppointmentDate;
                        this.HelpLineNo = s.HelpLineNo;
                        this.TokenNo = s.TokenNo; 
                        if (this.TokenNo == undefined || this.TokenNo == "" || this.TokenNo == "")
                            this.IsTokenNo = false;
                        else
                            this.IsTokenNo = true;

                        if (this.HelpLineNo == undefined || this.HelpLineNo == "" || this.HelpLineNo == "")
                            this.IsHelpLineNo = false;
                        else
                            this.IsHelpLineNo = true;
                        this.PrintPatientName = s.PatientName;
                        this.CPRNONumber = s.CPRNO;
                        this.IsBookingConfirmedPayment = true;
                        this.isValidPayment = true;
                        this.BookingConfirmedPayment.open();
                    }
                    else {
                        this.IsHelpLineNo = false;
                        this.IsBookingConfirmedPayment = true;
                        this.isValidPayment = false;
                        this.PayedPayAmount = s.PayAmount;
                        this.AppointmentDate = s.AppointmentDate;
                        this.trackid = s.trackid;
                        this.transactionNo = s.transaction_id;
                        this.transactionNo = s.transaction_id;
                        if (this.transactionNo == undefined || this.transactionNo == "" || this.transactionNo == "")
                            this.IsTransaction = false;
                        else
                            this.IsTransaction = true;
                        if (s.result == "CAPTURED")
                            this.PaymentErroMsg = "Payment success, we are unable to print the receipt no.  Please contact hospital.";
                        else if (s.result == "NOT+CAPTURED" || s.result == "NOTCAPTURE")
                            this.PaymentErroMsg = "Given card details are not correct. We are unable to process your payment. Please try again";
                        else if (s.result == "SERVERERROR")
                            this.PaymentErroMsg = "We are unable to process your payment. Please try again";
                        else if (s.result == "HOST+TIMEOUT")
                            this.PaymentErroMsg = "Time out. We are unable to process your payment. Please try again";
                        else if (s.result == "CANCELLED")
                            this.PaymentErroMsg = "Your process has been cancelled. We are unable to process your payment. Please try again";
                        else if (s.result == "DENIED+BY+RISK")
                            this.PaymentErroMsg = "Given card details are not correct. We are unable to process your payment. Please try again";
                        else
                            this.PaymentErroMsg = "We are unable to process your appointment.Please try again";
                        this.BookingConfirmedPayment.open();

                    }
                }
                else {
                    this.Alertpayment.close();
                    this._SecurityService.errorMessage = "Your session has expired. Please login again.";
                    this.router.navigate(["/Login"]);
                }
            },
            err => {
                this.Alertpayment.close();
                console.log("Error while getting data...");
            });
    }

    ChosenSlotValue(slotValue) {
        //this.loading = true;
        if (this.enableSaving == "YES") {
            this.isSlotValueChosen = true;
            this.slotErrorMessage = "NO";
            if (slotValue.value != "B" && slotValue.value != "L" && this.BookingType == "SLOT") {
                if (this.IsAdminUser == true) {
                    if (this.Querynumber != "" && this.Querynumber != undefined) {
                        this.patientId = this.Querynumber;
                        var userData: UserData = new UserData(this._SecurityService.pid, this._SecurityService.authentication, this.patientId, this._SecurityService.IsAdminUser);
                    }
                    else {
                        if (this.patientId == "" || this.patientId == undefined || this.patientId == null) {
                            this.emailMsg = "Before Choose the Slot Please enter the Patient id";
                            this.EmailAlertpopup.open();
                            this.loading = false;
                        }
                        else {
                            var userData: UserData = new UserData(this._SecurityService.pid, this._SecurityService.authentication, this.patientId, this._SecurityService.IsAdminUser);
                        }
                    }

                }
                else {
                    var userData: UserData = new UserData(this._SecurityService.pid, this._SecurityService.authentication, this._SecurityService.pid, this._SecurityService.IsAdminUser);
                }
                this.generalBooking.scheduledStartTime = slotValue.key;
                this.generalBooking.SessionCode = slotValue.SessionCode;
                this.selectedSlotClass = this.generalBooking.scheduledStartTime;
                for (var i = 0; i < this.timeSlotsArray.length; i++) {
                    if (this.timeSlotsArray[i].key == slotValue.key) {
                        this.chosenSlotValue = i;
                    }
                }
                if (this.chosenSlotValue != (this.timeSlotsArray.length - 1)) {
                    this.generalBooking.scheduledEndTime = this.timeSlotsArray[this.chosenSlotValue + 1].key;
                }
                else {
                    this.generalBooking.scheduledEndTime = this.scheduledEndTime;
                }
                this.generalBooking.BookingStatus = "B";
                this.checkcontrolbook = true;               
            }
        }
    }

    closeSlotAllotmentpopup() {
        this.slotAllotment.close();
    }

    SaveAppointmentPatient(radiotextvalue) {
        this.IsPopupPayment = false;
        this.generalBooking.PrivatePaymentType = "Private";
        this.generalBooking.IsDocumentAttached = this.IsDocumentAttached;
        if (radiotextvalue != undefined) {
            if (radiotextvalue == 0) {
                this.generalBooking.PrivatePaymentType = "Private";
            }
            else {
                this.generalBooking.PrivatePaymentType = "Insured";
            }
        }
        


        if (this.IsGuestEmailReq == true) {
            if (this.generalBooking.Email == null || this.generalBooking.Email == "" || this.generalBooking.Email == undefined) {
                this.IsSelectEmailRed = true;
            }
            else {
                this.IsSelectEmailRed = false;
            }
        }
        if (this.generalBooking.Email != null && this.generalBooking.Email != "" && this.generalBooking.Email != undefined) {
            if (this.generalBooking.Email.indexOf("@") <= 0 || (this.generalBooking.Email.indexOf(".") <= 0)) {
                this.IsSelectEmailValidation = true;
            }
            else {
                this.IsSelectEmailRed = false;
                this.IsSelectEmailValidation = false;
            }
        }
        else {
            if (this.IsSelectEmailRed == true) {
                this.IsSelectEmailRed = true;
                this.IsSelectEmailValidation = false;
            }
            else {
                this.IsSelectEmailRed = false;
                this.IsSelectEmailValidation = false;
            }
        }
        if (this.IsPatientOBGYN == true || this.IsPatientPediatric == true) {
            this.IsPatientValidFailed = true;
            this.IsPatientValid.open();
            if (this.IsPatientOBGYN == true) {
                this.message = "Visit is Not Allowed For Male Patients in this Department.";
            }
            if (this.IsPatientPediatric == true) {
                this.message = "Patient age should be less than '15' to schedule in pediatrics costcenter.";
            }

        }
        else {
            this.IsSearchMobileNumberRed = false;
            this.IsPatientValidFailed = false;

            if (this.generalBooking.PrivatePaymentType != null && this.generalBooking.PrivatePaymentType != undefined && this.generalBooking.PrivatePaymentType != ""
                && this.generalBooking.PrivatePaymentType == "Private"
                && this.SearchMobileNumber != null && this.TermsChecked == true && this.IsSelectEmailValidation == false && this.IsSelectEmailRed == false
                && this.SearchMobileNumber != "" && this.SearchMobileNumber != undefined && 
                this.PaymentType != "Y" && this.SearchMobileNumber.length >= 8
                && (this.IsUploadDocVisble == false || (this.IsUploadDocVisble == true && this.generalBooking.IsDocumentAttached == true)) && this.IsuploadValidationErrorMsg == false &&
                (this.IsUploadDocVisble == false || (this.IsUploadDocVisble == true && (this.generalBooking.CivilIdFront != null && this.generalBooking.CivilIdBack != null) || (this.generalBooking.PassportFront != null || this.generalBooking.PassportBack != null)))) {
                if (this.generalBooking.consultationFee != "0" && this.generalBooking.consultationFee != "0.00" && this.generalBooking.consultationFee != undefined && this.generalBooking.consultationFee != "") {
                    this.generalBooking.buttonActivity = "Payment";
                    this.SelecterrMsg1 = "";
                    this.generalBooking.MobileNo = this.SearchMobileNumber;
                    this.SaveAppointment();
                    this.viewModelPopup.close();
                    this.appointmentBooking = false;
                }
                else {
                    this.IsPatientValidFailed = true;
                    this.IsPatientValid.open();
                    this.message = "consultation Fee should be greater than zero.";
                }

            }
            else if (this.generalBooking.PrivatePaymentType != null && this.generalBooking.PrivatePaymentType != undefined && this.generalBooking.PrivatePaymentType != ""
                && this.generalBooking.PrivatePaymentType == "Private"  && this.SearchMobileNumber != null && this.TermsChecked == true && this.IsSelectEmailValidation == false && this.IsSelectEmailRed == false
                && this.SearchMobileNumber != "" && this.SearchMobileNumber != undefined && this.PaymentType == "Y" && this.SearchMobileNumber.length >= 8
                && (this.IsUploadDocVisble == false || (this.IsUploadDocVisble == true && this.generalBooking.IsDocumentAttached == true)) && this.IsuploadValidationErrorMsg == false &&
                (this.IsUploadDocVisble == false || (this.IsUploadDocVisble == true && (this.generalBooking.CivilIdFront != null && this.generalBooking.CivilIdBack != null) || (this.generalBooking.PassportFront != null || this.generalBooking.PassportBack != null)))) {
                if (this.generalBooking.consultationFee != "0" && this.generalBooking.consultationFee != "0.00" && this.generalBooking.consultationFee != undefined && this.generalBooking.consultationFee != "") {
                    var userData: UserData = new UserData(this._SecurityService.pid, this._SecurityService.authentication, this._SecurityService.pid, this._SecurityService.IsAdminUser);
                    this.IsSearchMobileNumberRed = false;
                    this.IsPatientValidFailed = false;
                    var userData: UserData = new UserData(this._SecurityService.pid, this._SecurityService.authentication, this._SecurityService.pid, this._SecurityService.IsAdminUser);
                    this.SelecterrMsg1 = "";
                    this.generalBooking.MobileNo = this.SearchMobileNumber;
                    this._bookingService.PaymentModeSelectionGuest(this.generalBooking, userData)
                        .subscribe(
                            p => {
                                this.loading = false;
                                if (p.credimaxPaymentDetails.length != 0 && p.requestParam.length != 0) {
                                    this.generalBooking.credimaxPaymentDetails = p.credimaxPaymentDetails;
                                    this.generalBooking.requestParam = p.requestParam;
                                    var secure_hash = this.generalBooking.requestParam[0].hashedString;
                                    var secretKey = this.generalBooking.requestParam[0].secretKey;
                                    this.generalBooking.requestParam[0].secure_hash = CryptoJS.enc.Base64.stringify(CryptoJS.HmacSHA256(secure_hash, secretKey));

                                }
                                else {

                                }
                            },
                            err => {
                                this.loading = false;
                                console.log("Error while getting department data...");
                            });
                    this.IsPopupPayment = true;
                    this.PopupPayment.open();
                }
                else {
                    this.IsPatientValidFailed = true;
                    this.IsPatientValid.open();
                    this.message = "consultation Fee should be greater than zero.";
                }
            }
            else {
                if ((this.generalBooking.PrivatePaymentType == null || this.generalBooking.PrivatePaymentType == "" || this.generalBooking.PrivatePaymentType == undefined)
                    && (this.generalBooking.patientId == null || this.generalBooking.patientId == "" || this.generalBooking.patientId == undefined) &&
                    (this.SearchMobileNumber == null || this.SearchMobileNumber == "" || this.SearchMobileNumber == undefined)) {
                    this.IsselectPatientSearch1 = true;
                    this.SelecterrMsg1 = "Please select one patient id and enter the phone number also";
                }
                else {
                    if (this.SearchMobileNumber == null || this.SearchMobileNumber == "" || this.SearchMobileNumber == undefined) {
                        this.IsselectPatientSearch1 = true;
                        this.SelecterrMsg1 = "Please enter the mobile number";
                    }
                    else if (this.SearchMobileNumber.length < 8) {
                        this.IsselectPatientSearch1 = true;
                        this.SelecterrMsg1 = "Mobile number should not be less than 8 digits";
                    }
                    else if (this.IsSelectEmailRed == true && (this.generalBooking.Email == null || this.generalBooking.Email == "" || this.generalBooking.Email == undefined)) {
                        this.IsselectPatientSearch1 = true;
                        this.SelecterrMsg1 = "Email is Required";
                    }
                    else if (this.IsSelectEmailValidation == true) {
                        this.IsselectPatientSearch1 = true;
                        this.SelecterrMsg1 = "Email is not valid";
                    }
                    else if (this.generalBooking.PrivatePaymentType == null || this.generalBooking.PrivatePaymentType == "" || this.generalBooking.PrivatePaymentType == undefined) {
                        this.IsselectPatientSearch1 = true;
                        if (this.payLaterStatus == "TRUE")
                            this.SelecterrMsg1 = "Please select whether you are proceeding as 'Insured' or 'Non-insured'.";
                        else
                            this.SelecterrMsg1 = "Please select Self Pay option";
                    }
                    else if (this.generalBooking.PrivatePaymentType == "Insured" || this.generalBooking.PrivatePaymentType == "Insured" || this.generalBooking.PrivatePaymentType == "Insured") {
                        this.IsselectPatientSearch1 = true;
                        this.SelecterrMsg1 = "Please select Self-Pay option";
                    }
                    else if (this.TermsChecked == false) {
                        this.IsselectPatientSearch1 = true;
                        this.SelecterrMsg1 = "Please select Terms and conditions option";
                    }
                    else if (this.IsUploadDocVisble == true && this.generalBooking.IsDocumentAttached == false) {
                        this.IsselectPatientSearch1 = true;
                        this.SelecterrMsg1 = "Please select the Document Attached option";
                    }
                    else if (this.IsuploadValidationErrorMsg == true) {
                        this.IsselectPatientSearch1 = true;
                        this.SelecterrMsg1 = "Please Upload Only .jpg,.png and pdf format Files";;
                    }
                    else if (this.IsUploadDocVisble == true && this.generalBooking.CivilIdFront == null && this.generalBooking.CivilIdBack == null && this.generalBooking.PassportFront == null && this.generalBooking.PassportBack == null) {
                        this.IsselectPatientSearch1 = true;
                        if (localStorage.getItem("HospitalName").toUpperCase() == "BSH") {
                            this.SelecterrMsg1 = "Please upload any one CPRNO or Passport image";
                        }
                        else {
                            this.SelecterrMsg1 = "Please upload any one Civil or Passport image";
                        }
                    }
                    else if (this.IsUploadDocVisble == true && (this.generalBooking.CivilIdFront == null && this.generalBooking.CivilIdBack != null) || (this.generalBooking.CivilIdFront != null && this.generalBooking.CivilIdBack == null)) {
                        if (this.generalBooking.CivilIdFront == null && this.generalBooking.CivilIdBack != null) {
                            this.IsselectPatientSearch1 = true;
                            if (localStorage.getItem("HospitalName").toUpperCase() == "BSH") {
                                this.SelecterrMsg1 = "Please upload the CPR NO Front image";
                            }
                            else {
                                this.SelecterrMsg1 = "Please upload the Civil ID Front image";
                            }
                        }
                        if (this.generalBooking.CivilIdFront != null && this.generalBooking.CivilIdBack == null) {
                            this.IsselectPatientSearch1 = true;
                            if (localStorage.getItem("HospitalName").toUpperCase() == "BSH") {
                                this.SelecterrMsg1 = "Please upload the CPR NO Back image";
                            }
                            else {
                                this.SelecterrMsg1 = "Please upload the Civil ID Back image";
                            }

                        }
                    }          
                    else {
                        this.IsselectPatientSearch1 = true;
                        this.SelecterrMsg1 = "Please select one patient id";
                    }

                }
            }
        }
    }


    SaveAppointmentPatientLater(radiotextvalue) {
        this.generalBooking.PrivatePaymentType = "Private";
        this.generalBooking.IsDocumentAttached = this.IsDocumentAttached;
        if (radiotextvalue != undefined) {
            if (radiotextvalue == 0) {
                this.generalBooking.PrivatePaymentType = "Private";
            }
            else {
                this.generalBooking.PrivatePaymentType = "Insured";
            }
        }
        
        if (this.IsGuestEmailReq == true) {
            if (this.generalBooking.Email == null || this.generalBooking.Email == "" || this.generalBooking.Email == undefined) {
                this.IsSelectEmailRed = true;
            }
            else {
                this.IsSelectEmailValidation = false;
            }
        }
        if (this.generalBooking.Email != null && this.generalBooking.Email != "" && this.generalBooking.Email != undefined) {
            if (this.generalBooking.Email.indexOf("@") <= 0 || (this.generalBooking.Email.indexOf(".") <= 0)) {
                this.IsSelectEmailValidation = true;
            }
            else {
                this.IsSelectEmailValidation = false;
                this.IsSelectEmailRed = false;
            }
        }
        else {
            if (this.IsSelectEmailRed == true) {
                this.IsSelectEmailRed = true;
                this.IsSelectEmailValidation = false;
            }
            else {
                this.IsSelectEmailRed = false;
                this.IsSelectEmailValidation = false;
            }
        }
        if (this.IsPatientOBGYN == true || this.IsPatientPediatric == true) {
            this.IsPatientValidFailed = true;
            this.IsPatientValid.open();
            if (this.IsPatientOBGYN == true) {
                this.message = "Visit is Not Allowed For Male Patients in this Department.";
            }
            if (this.IsPatientPediatric == true) {
                this.message = "Patient age should be less than '15' to schedule in pediatrics costcenter.";
            }

        }
        else {
            this.IsPatientValidFailed = false;
            if (this.generalBooking.PrivatePaymentType != null && this.generalBooking.PrivatePaymentType != undefined && this.generalBooking.PrivatePaymentType != ""
                && this.SearchMobileNumber != null
                && this.SearchMobileNumber != "" && this.SearchMobileNumber != undefined && this.TermsChecked == true
                && this.IsSelectEmailValidation == false && this.IsSelectEmailRed == false && this.SearchMobileNumber.length >= 8
                && (this.IsUploadDocVisble == false || (this.IsUploadDocVisble == true && this.generalBooking.IsDocumentAttached == true)) && this.IsuploadValidationErrorMsg == false &&
                (this.IsUploadDocVisble == false || (this.IsUploadDocVisble == true && (this.generalBooking.CivilIdFront != null && this.generalBooking.CivilIdBack != null) || (this.generalBooking.PassportFront != null || this.generalBooking.PassportBack != null)))) {
                this.generalBooking.buttonActivity = "PaymentLater";
                this.generalBooking.MobileNo = this.SearchMobileNumber;
                this.SelecterrMsg1 = "";
                this.PayLaterAppointmentSave();
                this.viewModelPopup.close();
                this.appointmentBooking = false;
            }
            else {
                if ((this.generalBooking.PrivatePaymentType == null || this.generalBooking.PrivatePaymentType == "" || this.generalBooking.PrivatePaymentType == undefined)
                    && (this.generalBooking.patientId == null || this.generalBooking.patientId == "" || this.generalBooking.patientId == undefined) &&
                    (this.SearchMobileNumber == null || this.SearchMobileNumber == "" || this.SearchMobileNumber == undefined)) {
                    this.IsselectPatientSearch1 = true;
                    this.SelecterrMsg1 = "Please select one patient id and enter the phone number also";
                }
                else {
                    if (this.SearchMobileNumber == null || this.SearchMobileNumber == "" || this.SearchMobileNumber == undefined) {
                        this.IsselectPatientSearch1 = true;
                        this.SelecterrMsg1 = "Please enter the mobile number";
                    }
                    else if (this.SearchMobileNumber.length < 8) {
                        this.IsselectPatientSearch1 = true;
                        this.SelecterrMsg1 = "Mobile number should not be less than 8 digits";
                    }
                    else if (this.IsSelectEmailRed == true && (this.generalBooking.Email == null || this.generalBooking.Email == "" || this.generalBooking.Email == undefined)) {
                        this.IsselectPatientSearch1 = true;
                        this.SelecterrMsg1 = "Email is Required";
                    }
                    else if (this.IsSelectEmailValidation == true) {
                        this.IsselectPatientSearch1 = true;
                        this.SelecterrMsg1 = "Email is not valid";
                    }
                    else if (this.generalBooking.PrivatePaymentType == null || this.generalBooking.PrivatePaymentType == "" || this.generalBooking.PrivatePaymentType == undefined) {
                        this.IsselectPatientSearch1 = true;
                        if (this.payLaterStatus == "TRUE")
                            this.SelecterrMsg1 = "Please select whether you are proceeding as 'Insured' or 'Non-insured'.";
                        else
                            this.SelecterrMsg1 = "Please select Self Pay option";
                    }
                    else if (this.TermsChecked == false) {
                        this.IsselectPatientSearch1 = true;
                        this.SelecterrMsg1 = "Please select Terms and conditions option";
                    }
                    else if (this.IsUploadDocVisble == true && this.generalBooking.IsDocumentAttached == false) {
                        this.IsselectPatientSearch1 = true;
                        this.SelecterrMsg1 = "Please select the Document Attached option";
                    }
                    else if (this.IsuploadValidationErrorMsg == true) {
                        this.IsselectPatientSearch1 = true;
                        this.SelecterrMsg1 = "Please Upload Only .jpg,.png and pdf format Files";;
                    }
                    else if (this.IsUploadDocVisble == true && this.generalBooking.CivilIdFront == null && this.generalBooking.CivilIdBack == null && this.generalBooking.PassportFront == null && this.generalBooking.PassportBack == null) {
                        this.IsselectPatientSearch1 = true;
                        if (localStorage.getItem("HospitalName").toUpperCase() == "BSH") {
                            this.SelecterrMsg1 = "Please upload any one CPRNO or Passport image";
                        }
                        else {
                            this.SelecterrMsg1 = "Please upload any one Civil or Passport image";
                        }
                    }
                    else if (this.IsUploadDocVisble == true && (this.generalBooking.CivilIdFront == null && this.generalBooking.CivilIdBack != null) || (this.generalBooking.CivilIdFront != null && this.generalBooking.CivilIdBack == null)) {
                        if (this.generalBooking.CivilIdFront == null && this.generalBooking.CivilIdBack != null) {
                            this.IsselectPatientSearch1 = true;
                            if (localStorage.getItem("HospitalName").toUpperCase() == "BSH") {
                                this.SelecterrMsg1 = "Please upload the CPR NO Front image";
                            }
                            else {
                                this.SelecterrMsg1 = "Please upload the Civil ID Front image";
                            }
                        }
                        if (this.generalBooking.CivilIdFront != null && this.generalBooking.CivilIdBack == null) {
                            this.IsselectPatientSearch1 = true;
                            if (localStorage.getItem("HospitalName").toUpperCase() == "BSH") {
                                this.SelecterrMsg1 = "Please upload the CPR NO Back image";
                            }
                            else {
                                this.SelecterrMsg1 = "Please upload the Civil ID Back image";
                            }

                        }
                    }  
                    else {
                        this.IsselectPatientSearch1 = true;
                        this.SelecterrMsg1 = "Please select one patient id";
                    }

                }
            }
        }
    }
    SlotCancel() {
        this.loading = true;
            this.slotErrorMessage = "NO";
            var userData: UserData = new UserData(this._SecurityService.pid, this._SecurityService.authentication, this._SecurityService.pid, this._SecurityService.IsAdminUser);

            this.selectedSlotClass = this.generalBooking.scheduledStartTime;

            this.generalBooking.BookingStatus = "N";
            this._bookingService.updateChosenSlot(this.generalBooking, userData)
                .subscribe(
                    p => {
                        this.loading = false;
                        if (p.SessionTimeout == "Session Expired") {
                            if (p.message.length != 0) {
                                this.selectedSlotClass = "";
                            }
                            else {
                                this.selectedSlotClass = "";
                                this.slotBookingFailed = false;
                                this.slotAllotment.close();
                            }
                        }
                        else if (p.SessionTimeout == "Session Expired") {
                            this._SecurityService.errorMessage = "Your session has expired. Please login again.";
                            this.router.navigate(["/Login"]);
                            this.loading = false;
                        }
                    },
                    err => {
                        this.loading = false;
                        console.log("Error while getting department data...");
                    });

        this.viewModelPopup.close();
    }

    SaveAppointmentSLOT() {
        this.TermsChecked = false;
        this.SearchMobileNumber = "";
        if (this.ISDocDepartOption == this.generalBooking.departmentId && this.ISReqDocOption == true)
            this.IsUploadDocVisble = true;
        else
            this.IsUploadDocVisble = false;
        //if (localStorage.getItem("HospitalName").toUpperCase() == "BSH") {
        //    if (this.ISDocDepartOption == this.generalBooking.departmentId) {
        //        this.IsProceedPaybutton = true;
        //    }
        //    else {
        //        this.IsProceedPaybutton = false;
        //    }
        //}
        if (this.BookingType != "SLOT") {
            this.generalBooking.scheduledStartTime = this.JnhFirstSlot;
            this.generalBooking.scheduledEndTime = "";
            this.generalBooking.BookingStatus = "B";
        }
        if ((this.isSlotValueChosen && this.BookingType == "SLOT") || (this.BookingType != "SLOT" && this.JnhFirstSlot != "" && this.JnhFirstSlot != undefined && this.JnhFirstSlot != null)) {
            this.slotErrorMessage = "NO";
            if (this.generalBooking.IS_BOOK_ALLOW != null && this.generalBooking.IS_BOOK_ALLOW != "" && this.generalBooking.IS_BOOK_ALLOW != undefined && this.generalBooking.IS_BOOK_ALLOW == 'N') {
                this.IsBookingDoctorOnline = true;
                this.BookingDoctorOnline.open();
            }
            else {
                this.generalBooking.BookingStatus = "L";
                var userData: UserData = new UserData(this._SecurityService.pid, this._SecurityService.authentication, this._SecurityService.pid, this._SecurityService.IsAdminUser);
                if ((this.checkcontrolbook == true && this.BookingType == "SLOT") || (this.BookingType != "SLOT")) {
                    this._bookingService.updateChosenSlot(this.generalBooking, userData)
                        .subscribe(
                            p => {
                                this.loading = false;
                                if (p.SessionTimeout != "Session Expired") {
                                    if (p.message != 0 && p.SessionTimeout != "Session Expired") {
                                        this.message = p.message;
                                        this.slotBookingFailed = true;
                                        this.selectedSlotClass = "";
                                        this.slotAllotment.open();
                                        this.checkcontrolbook = false;
                                    }
                                    else {
                                        this.slotBookingFailed = false;
                                        this.slotAllotment.close();
                                        this.generalBooking.ScheduleAppNo = p.ScheduleAppNo;
                                        this.checkcontrolbook = false;
                                        this.IsBookingDoctorOnline = false;
                                        this.viewModelPopup.close();
                                        this.appointmentBooking = true;
                                    }
                                }
                                else if (p.SessionTimeout == "Session Expired") {
                                    this._SecurityService.errorMessage = "Your session has expired. Please login again.";
                                    this.router.navigate(["/Login"]);
                                    this.loading = false;
                                }
                            },
                            err => {
                                this.loading = false;
                                console.log("Error while getting department data...");
                            });
                }
                else {
                    this.checkcontrolbook = false;

                }

            }
            this.isSlotValueChosen = false;
        }
        else {
            this.slotErrorMessage = "YES";
            this.isSlotValueChosen = true;
        }
    }

    SaveAppointment() {
            this.slotErrorMessage = "NO";
            this.loading = true;
            if (this.IsAdminUser == true) {
                if (this.Querynumber != "" && this.Querynumber != undefined) {
                    this.patientId = this.Querynumber;
                    var userData: UserData = new UserData(this._SecurityService.pid, this._SecurityService.authentication, this.patientId, this._SecurityService.IsAdminUser);
                }
                else {
                    if (this.patientId == "" || this.patientId == undefined || this.patientId == null) {                       
                        this.emailMsg = "Please enter the Patient id";
                        this.EmailAlertpopup.open();
                        this.loading = false;
                    }
                    else {
                        var userData: UserData = new UserData(this._SecurityService.pid, this._SecurityService.authentication, this.patientId, this._SecurityService.IsAdminUser);
                    }                    
                }
            }
            else {
                var userData: UserData = new UserData(this._SecurityService.pid, this._SecurityService.authentication, this._SecurityService.pid, this._SecurityService.IsAdminUser);
            }           
            this._bookingService.SaveApointmentRequest(this.generalBooking, userData)
                .subscribe(
                p => {
                        if (p.ErrorMessage == "'email' post variable not found") {
                            this.emailMsg = "We are not able to process your payment as you have not registered with your email ID. Please update your email id before proceeding with payment.";
                            this.EmailAlertpopup.open();
                            this.loading = false;
                        }
                        else if (p.ErrorMessage != null && p.ErrorMessage != "The Pay Page is created." && p.ErrorMessage.search("Slot is booked/blocked. Please refresh the screen") == -1) {
                            this.emailMsg = p.ErrorMessage;
                             this.TokenNegativeConsultationCharge = true;
                            this.EmailAlertpopup.open();
                            this.loading = false;
                        }
                        else if (p.ErrorMessage != null && p.ErrorMessage.search("Slot is booked/blocked. Please refresh the screen") != -1) {
                            this.isSlotValueChosen = false;
                            this.message = "This slot time is already booked. Please chose another slot timing.";
                            this.slotBookingFailed = true;
                            this.selectedSlotClass = "";
                            this.slotAllotment.open();
                            this.loading = false;
                        }
                   
                    else if (p.sessionExpiry && p.SessionTimeout != "Session Expired") {
                        if (p != null) {
                            this._SecurityService.errorMessage = "";
                            if (this.generalBooking.ISReschedule == "Reschedule") {
                                if (p.AppointmentResult == "Success") {
                                    this.BookingConfirmed.open();
                                    this.NegativeConsultationCharge = false;
                                    this.IsBookingConfirmed = true;
                                    this.loading = false;
                                }
                                else {
                                    this.BookingConfirmed.open();
                                    this.IsBookingConfirmed = false;
                                    this.loading = false;
                                }
                            }
                            else if (this.generalBooking.VisitNo != null && this.generalBooking.color == "red") {
                                if (p.AppointmentResult == "Success") {
                                    this.BookingConfirmed.open();
                                    this.NegativeConsultationCharge = false;
                                    this.IsBookingConfirmed = true;
                                    this.loading = false;
                                }
                                else {
                                    this.BookingConfirmed.open();
                                    this.IsBookingConfirmed = false;

                                }
                            }
                            else {
                                if (this.generalBooking.PaymentTypeMode == "MAXWALLET") { this.BSHMaxWalletQrCode(); }
                                else {
                                    this.redirectString = p.PaymentRedirectSiteUrl;
                                    if (p.PaymentRedirectSiteUrl != null && p.AppointmentResult == "Success" && this.generalBooking.consultationFee.indexOf('-') <= 0) {
                                        window.location.href = this.redirectString;
                                    }

                                    else if (p.Amount == null) {
                                        this.BookingConfirmed.open();
                                        this.NegativeConsultationCharge = true;
                                        this.IsBookingConfirmed = true;
                                        this.loading = false;
                                    }

                                    else if (this.generalBooking.consultationFee.indexOf('-') <= 0) {
                                        this.BookingConfirmed.open();
                                        this.NegativeConsultationCharge = true;
                                        this.IsBookingConfirmed = true;
                                        this.loading = false;
                                    }
                                    else {
                                        this.NegativeConsultationCharge = false;
                                        this.IsBookingConfirmed = false;
                                        this.BookingConfirmed.open();
                                        this.isValid = false;
                                        this.loading = false;
                                    }
                                }
                            }

                        }
                        else {
                            this.NegativeConsultationCharge = false;
                            this.IsBookingConfirmed = false;
                            this.isValid = true;
                            this.loading = false;
                        }
                    }

                    else if (!p.sessionExpiry) {
                        this._SecurityService.errorMessage = "Your session has expired. Please login again.";
                        this.router.navigate(["/Login"]);
                        this.loading = false;
                    }
                },
                err => {
                    console.log("Error while getting data...");
                });

    }

    onDateChanged(event: IMyDateModel) {
        if (event != undefined) {
            if (event.formatted != null && event.formatted != undefined && event.formatted != "") {
                if (this.HospitalName == "JNH") {
                    var dt = new Date(event.date.year, event.date.month - 1, event.date.day + 1)
                    this.activebutton = dt.getDay() + 1;
                }
                else {
                    var dt = new Date(event.date.year, event.date.month - 1, event.date.day);
                    this.activebutton = dt.getDay();
                }
                if (this.activebutton == 0)
                    this.activebutton = 7;
                this.bookingFilter.FromDate = event.formatted.toString();
                this.bookingFilter.FromDate = this.bookingFilter.FromDate.replace(".", "/");
                this.date = this.bookingFilter.FromDate;
                //this.appDate1 = { date: { year: event.date.year, month: event.date.month + 1, day: event.date.day } };
            }
            else {
                var d = new Date();
                this.appDate = { date: { year: this.year.getFullYear(), month: this.year.getMonth() + 1, day: this.year.getDate() } };
                //this.appDate1 = { date: { year: this.year.getFullYear(), month: this.year.getMonth() + 1, day: this.year.getDate() } };
                this.activebutton = d.getDay();
                this.clickedDate = ("0" + d.getDate()).slice(-2) + "/" + ("0" + (d.getMonth() + 1)).slice(-2) + "/" + d.getFullYear();
                this.bookingFilter.FromDate = this.clickedDate;
                this.date = this.bookingFilter.FromDate;
            }        
        }
        this.activebutton1 = this.activebutton;
        this.LoadFilterReports();
    }


    onDateChanged1(event: IMyDateModel) {
        this.SlotVisible = false;
        if (event != undefined) {
            if (event.formatted != null && event.formatted != undefined && event.formatted != "") {
                var dt = new Date(event.date.year, event.date.month - 1, event.date.day);
                this.activebutton1 = dt.getDay();

                this.bookingFilter.FromDate = event.formatted.toString();
                this.bookingFilter.FromDate = this.bookingFilter.FromDate.replace(".", "/");
                this.date = this.bookingFilter.FromDate;
            }
            else {
                var d = new Date();
                this.appDate1 = { date: { year: this.year.getFullYear(), month: this.year.getMonth() + 1, day: this.year.getDate() } };
                this.activebutton1 = d.getDay();
                this.clickedDate = ("0" + d.getDate()).slice(-2) + "/" + ("0" + (d.getMonth() + 1)).slice(-2) + "/" + d.getFullYear();
                this.bookingFilter.FromDate = this.clickedDate;
                this.date = this.bookingFilter.FromDate;
            }
        }
        //  this.LoadFilterReports();
        this.showBookingSlots1(this.generalBooking.doctorId);
    }

    onDepartmentchange(event) {
        if (this.patientSex == "Male" && event == "100305") {
            this.enableSaving = "NO";
        }

        else if (event == "100313" && this.patientAge > 15) {
            this.enableSaving = "NO";
        }

        else {
            this.enableSaving = "YES";
        }
        this.LoadFilterReports();
    }

    getElement(data) {
        if (typeof (data) == 'string') {
            return document.getElementById(data);
        }
        if (typeof (data) == 'object' && data instanceof Element) {
            return data;
        }
        return null;
    }

    buildBookingfilter(): UserData {
        if (this.bookingFilter.FromDate == undefined) {
            this.bookingFilter.FromDate = this.date;
        }
        if (this.bookingFilter.ToTime == undefined) {
            this.bookingFilter.ToTime = "23";
        }
        if (this.bookingFilter.FromTime == undefined) {
            this.bookingFilter.FromTime = "09";
        }
        var userData: UserData = new UserData(this._SecurityService.pid, this._SecurityService.authentication, this._SecurityService.pid, this._SecurityService.IsAdminUser);
        if (this.bookingFilter) {
            userData.DayCode = this.activebutton.toString();
            userData.DateFrom = this.bookingFilter.FromDate;
            userData.DepartmentID = this.bookingFilter.DEPT_CODE;
            userData.FromTime = this.bookingFilter.FromTime;
            userData.ToTime = this.bookingFilter.ToTime;
            userData.DayCode = this.activebutton.toString();
            userData.LocationId = this.generalBooking.LocationId;
            this.generalBooking.LocationId = this.generalBooking.LocationId;
            this.bookingFilter.DEPT_CODE = this.bookingFilter.DEPT_CODE == null ? "0" : this.bookingFilter.DEPT_CODE;
            userData.DepartmentID = this.bookingFilter.DEPT_CODE;
            if (this.IsLocationChange == true) {
                // this.generalBooking.departmentId = this.generalBooking.departmentId == null ? "0" : this.generalBooking.departmentId;	
                userData.DepartmentID = "NULL";
            }
        }
        return userData;
    }

    LoadDepartments() {
        var userData: UserData = new UserData(this._SecurityService.pid, this._SecurityService.authentication, this._SecurityService.pid, this._SecurityService.IsAdminUser);
        this.loading = true;
        this._bookingService.getDepartments(userData, this.generalBooking.LocationId)
            .subscribe(
            p => {
                if (p.SessionTimeout != "Session Expired" && p.SessionTimeout != "Session Expired") {
                    this.depts = p.Departments;
                    this.BookingType = p.BookingType;
                    this.ISSelfPayOption = p.ISSelfPayOption;
                    if (this.QueryResult == "Reschedule" || this.Querynumber == "Reschedule") {
                        this.bookingFilter.DEPT_CODE = this.generalBooking.ReScheduleDeptNumber;
                    }
                    else {
                        if (p.DefaultDept != null)
                            this.bookingFilter.DEPT_CODE = p.DefaultDept;
                    }
                    this.patientSex = p.PatientSex;
                    this.patientAge = p.PatientAge;
                    this.PaymentGatewayType = p.PaymentGatewayType;
                    this.PaymentType = p.PaymentType;
                    this.CPRNOlength = p.DefaultCPRNOLength;
                    this.IsProceedPayNow = p.IsProceedPayNow;
                    if (p.IsProceedPayNow == "FALSE")
                        this.IsProceedPaybutton = false;
                    else
                        this.IsProceedPaybutton = true;

                    if (Number(this.CPRNOlength) == 9)
                        this.mobilePlaceHolder = "Enter mobile no. in Bahrain(Without +973)";
                    else
                        this.mobilePlaceHolder = "Enter mobile no. in Kuwait(Without +965)";

                    if (this.BookingType == "TOKEN")
                        this.mobilePlaceHolder = "Enter mobile no";
                    if (p.ISReqDocOption == "TRUE")
                        this.ISReqDocOption = true;
                    else
                        this.ISReqDocOption = false;
                    if (p.ISDocDepartOption != null)
                        this.ISDocDepartOption = p.ISDocDepartOption;

                    if (p.IsGuestPatientEmailReq == "TRUE") {
                        this.IsGuestEmailReq = true;
                    }
                }
                else {
                    this.loading = false;
                    this._SecurityService.errorMessage = "Your session has expired. Please login again.";
                    this.router.navigate(["/Login"]);
                }
            },
            err => {
                this.loading = false;
                console.log("Error while getting department data...");
            });
    }

    DoctorSearch() {
        var userData: UserData = new UserData(this._SecurityService.pid, this._SecurityService.authentication, this._SecurityService.pid, this._SecurityService.IsAdminUser);

        userData.FromTime = "00:00";
        userData.ToTime = "23:00";


        userData.DateFrom = this.date;
        userData.DepartmentID = "0";
        userData.DayCode = this.activebutton.toString();
        this.generalBooking.departmentId = "0";
        this.bookingFilter.DEPT_CODE = "0";
        userData.DoctorName = this.doctorName;
        userData.LocationId = this.generalBooking.LocationId;
        this.loading = true;
        this._bookingService.SearchBookingReportsBooking(userData)
            .subscribe(
                p => {
                    if (p != null) {
                        this.dataSource = p.BookingList;
                        this.dataSourceOriginal = this.dataSource;
                        this.buildGrid(this.dataSource);
                        this.loading = false;
                    }
                },
                err => {
                    this.loading = false;
                    console.log("Error while getting booking data...");
                });
    }

    LoadBookingReports() {
        if (this.IsAdminUser == true) {
            if (this.Querynumber != "" && this.Querynumber != undefined) {
                this.patientId = this.Querynumber;
            }
            var userData: UserData = new UserData(this._SecurityService.pid, this._SecurityService.authentication, this.patientId, this._SecurityService.IsAdminUser);
        }
        else {
            var userData: UserData = new UserData(this._SecurityService.pid, this._SecurityService.authentication, this._SecurityService.pid, this._SecurityService.IsAdminUser);
        }

        userData.FromTime = "9:00";
        userData.ToTime = "17:00";
        userData.DateFrom = this.date;
        if (this.Querynumber == "Reschedule" || this.QueryResult == "Reschedule") {
            userData.DepartmentID = this.generalBooking.ReScheduleDeptNumber;
        }
        else {
            userData.DepartmentID = "NULL";
        }
        userData.DayCode = this.activebutton.toString();
        this.loading = true;

        this._bookingService.getBookingReports(userData)
            .subscribe(
            p => {
                if (p != null && p.sessionExpiry && p.SessionTimeout != "Session Expired") {

                    this.dataSource = p.BookingList;
                    this.dataSourceOriginal = this.dataSource;
                    this.buildGrid(this.dataSource);
                    this.loading = false;
                    this._SecurityService.errorMessage = "";
                }
                else if (!p.sessionExpiry) {
                    this.loading = false;
                    this._SecurityService.errorMessage = "Your session has expired. Please login again.";
                    this.router.navigate(["/Login"]);
                }
            },
            err => {
                this.loading = false;
                console.log("Error while getting booking data...");
            });
    }

    GetSplittedTimeSlots(timeslotArray, drCode) {
        var testnew = 0;
        this.selectedSlotDrCode = drCode;
        this.JnhFirstSlot = "";

        for (var i = 0; i < timeslotArray.length; i++) {
            let kv: Bookingkeyvaluepair = new Bookingkeyvaluepair();
            kv.key = timeslotArray[i].SlotTime;
            if (this.generalBooking.SLOT == "Total Slot : 0") {
                kv.value = "B";
            }
            else {
                kv.value = timeslotArray[i].SlotStatusValue;
            }
            if (kv.value == "N" && testnew == 0) {
                this.JnhFirstSlot = kv.key;
                testnew = 1;
                this.generalBooking.SessionCode = timeslotArray[i].SessionCode;
                this.generalBooking.CLINIC_CODE = timeslotArray[i].ClinicCode;
            }
            kv.slotMessage = this.slotMessage;
            kv.SessionCode = timeslotArray[i].SessionCode;
            this.timeSlotsArray.push(kv);
        }
    }

    LoadFilterReports() {
        var userData: UserData = this.buildBookingfilter();
        this.loading = true;

        this._bookingService.getFilterReports(userData)
            .subscribe(
            p => {
                if (p.sessionExpiry && p.SessionTimeout != "Session Expired") {
                    this.dataSource = p.BookingList;
                    this.buildGrid(this.dataSource);
                    this.loading = false;
                }
                else {
                    this.loading = false;
                    this._SecurityService.errorMessage = "Your session has expired. Please login again.";
                    this.router.navigate(["/Login"]);
                }
            },
            err => {
                this.loading = false;
                console.log("Error while getting booking data...");
            });
    }

    public buildGrid(Data) {
        try {
            this.buildColumn();

            var dgrid = jQuery("#grdBookings").data("kendoGrid");
            if (dgrid) {
                $('#grdBookings').data().kendoGrid.destroy();
                $('#grdBookings').empty();
            }
            jQuery('#grdBookings').kendoGrid({
                editable: false,
                filterable: true,
                pageable: {
                    pageSizes: [5, 10, 25, 50, 100]
                },
                scrollable: false,
                sortable: true,
                columns: this.columns,
                filterMenuInit: function (e) {
                    if (e.field != "SubmissionID" && e.field != "NameInsuredOrTreatyTitle") {
                        var filterMultiCheck = e.sender.thead.find("[data-field=" + e.field + "]").data("kendoFilterMultiCheck");
                        filterMultiCheck.container.empty();
                        var chkSourceData = filterMultiCheck.checkSource.data();

                        chkSourceData.sort(function (a: any, b: any) {
                            var sortStatus = 0;

                            if (a[e.field].toLowerCase() < b[e.field].toLowerCase()) {
                                sortStatus = -1;
                            } else if (a[e.field].toLowerCase() > b[e.field].toLowerCase()) {
                                sortStatus = 1;
                            }

                            return sortStatus;
                        });

                        filterMultiCheck.checkSource.data(chkSourceData.toJSON());
                        filterMultiCheck.createCheckBoxes();
                    }
                },
                dataBinding: this.databinding,
                dataSource: {
                    data: Data,
                    pageSize: Data != null ? 10 : 0,
                    sort: [                       
                        {
                            field: "DisplayOrder", dir: "asc"
                        },
                        {
                            field: "DoctorName",
                            dir: "asc"
                        }],
                },
            });
            jQuery("#grdBookings").data("kendoGrid").wrapper.children(".k-grid-pager").find("span.k-input").html('All');
            var gridPage = jQuery("#grdBookings").data("kendoGrid");
            gridPage.wrapper.children(".k-grid-pager").find("span.k-input").html('10');
            var pageSizeDropDownList = gridPage.wrapper.children(".k-grid-pager").find("select").data("kendoDropDownList");
            pageSizeDropDownList.bind("change", function (e: any) {
                gridPage.wrapper.children(".k-grid-pager").find("span.k-input").html(gridPage.wrapper.children(".k-grid-pager").find("select").find('option:selected').text());
            });
        }
        catch (ex) {
            this.handleError(ex);
        }
    }

    buildColumn(): void {
        this.columns = [
            {
                field: "color",
                title: " ",
                template: kendo.template("#=this.buildBookingReportRow(DoctorName,NativeDoctorName,NativeDeptName, DoctorCode,DisplayOrder, DEPT_CODE, SLOT, DAYS, Qualification, Designation, Speciality, ImageByte, DeptName, color, DoctorType, Remarks)#").bind(this)
            }
        ];
    }

    buildBookingReportRow(DoctorName, NativeDoctorName,NativeDeptName,DoctorCode: string, DisplayOrder: number, DEPT_CODE, SLOT, DAYS, Qualification, Designation, Speciality, ImageByte, DeptName, color, DoctorType, Remarks) {
        var dept = DEPT_CODE;
        var drCode = DoctorCode;
        var Img = "data:image/JPEG;base64," + ImageByte;
        var doctorColor = color;

        var l1 = "<div class='visit_wrap doc_deta_wrap'>";
        var l2 = "    <div class='doc-img-wrap'>  <img src=" + Img + " /> </div>";
        var l3 = "    <div class='doctor_date graybg pad_le130'>";
        var l4 = "        <span class='doc-name green_text'> <strong>" + DoctorName + " </strong> , ( " + DeptName + " ) </span>";
        var l44 = "        <span class='doc-name green_text'> <strong style='color:red'>" + DoctorName + " </strong>  ( " + DeptName + " ) </span>";
        var l45 = "        <span class='doc-name green_text'> <strong style='color:red;unicode-bidi: embed'>" +'/'+ NativeDoctorName + " </strong>  ( " + NativeDeptName  + " ) </span>";
        var l5 = "        <span class='pull-right font13'></span>";
        var l6 = "    </div>";
        var l7 = "    <div class='doc_short_desc pad_le130'>";
        var l81 = "        <span class='doc-desc' style='color: #F35933;padding:0px'> Position:" + DoctorType + " </span> ";
        var l8 = "        <span class='doc-desc'> " + Remarks + " </span> ";
        var l9 = "    </div>";
        var l10 = "    <div class='tot_slot_book pad_le130'>";
        var l11 = "        <span class='ttlslot green_text'>" + SLOT + "</span>";
        var l12 = "        <span class='availdays font13'> " + DAYS + " </span>";
        var l13 = "        <span class='pull-right green-bg bookbtn'  onclick=bookingGrid.showBookingSlots('" + DoctorCode + "')> <i class='fa fa-calendar-plus-o' aria-hidden='true'></i> Book Appointment </span>";
        var l16 = "        <span class='pull-right green-bg bookbtn disableBtn'> <i class='fa fa-calendar-plus-o' aria-hidden='true'></i> Book Appointment </span>";
        var l14 = "    </div>";
        var l15 = "</div>"
        if (doctorColor != null && doctorColor != "" && doctorColor != undefined && doctorColor =="red") {
            if (this.activebutton == 9)
                return l1 + l2 + l3 + l44 + l45+ l5 + l6 + l7 + l81 + l8 + l9 + l10 + l11 + l12 + l16 + l14 + l15;
            else
                return l1 + l2 + l3 + l44 + l45 +l5 + l6 + l7 + l81 + l8+ l9 + l10 + l11 + l12 + l13 + l14 + l15;
        }
        else {
            if (this.activebutton == 9)
                return l1 + l2 + l3 + l4 + l5 + l6 + l7 + l81 + l8 + l9 + l10 + l11 + l12 + l16 + l14 + l15;
            else
                return l1 + l2 + l3 + l4 + l5 + l6 + l7 + l81 + l8 + l9 + l10 + l11 + l12 + l13 + l14 + l15;
        }
    }

    databinding(e: any) {
        try {
            var grid = jQuery("#grdBookings").data("kendoGrid");
            var totalCount = grid.dataSource.total();
            var pageSizes = [{ text: "5", value: 5 }, { text: "10", value: 10 }, { text: "25", value: 25 }, { text: "50", value: 50 }, { text: "100", value: 100 }, { text: "All", value: totalCount }];
            var pagerdropdownBox = jQuery('.k-pager-sizes select[data-role="dropdownlist"]').data('kendoDropDownList');
            var pagerds = new kendo.data.DataSource({
                data: pageSizes
            });
            pagerdropdownBox.setDataSource(pagerds);
        }
        catch (e) {

        }
    }

    ScheduledAppointments() {
        this.router.navigate(["/Appointments"]);
    }
    PaymentFailedOk() {
        this.BookingConfirmed.close();
        this.viewModelPopup.close();
    }

    private handleError(error: any) {
        console.log("error : " + error);
    }

    Emailpopup() {
        this.EmailAlertpopup.close();
        this.viewModelPopup.close();
    }

    PayLaterAppointmentSave() {
        if ((this.BookingType == "SLOT") || (this.BookingType != "SLOT"))  {
            this.slotErrorMessage = "NO";
            if (this.IsAdminUser == true) {
                if (this.Querynumber != "" && this.Querynumber != undefined) {
                    this.patientId = this.Querynumber;
                    var userData: UserData = new UserData(this._SecurityService.pid, this._SecurityService.authentication, this.patientId, this._SecurityService.IsAdminUser);
                }
                else {
                    if (this.patientId == "" || this.patientId == undefined || this.patientId == null) {
                        this.emailMsg = "Please enter the Patient id";
                        this.EmailAlertpopup.open();
                        this.loading = false;
                    }
                    else {
                        var userData: UserData = new UserData(this._SecurityService.pid, this._SecurityService.authentication, this.patientId, this._SecurityService.IsAdminUser);
                    }

                }

            }
            else {
                var userData: UserData = new UserData(this._SecurityService.pid, this._SecurityService.authentication, this._SecurityService.pid, this._SecurityService.IsAdminUser);
            }
            
            this._bookingService.PayLaterAppointmentSave(this.generalBooking, userData)
                .subscribe(
                p => {
                    if (p != null && p == "Success") {
                        this.paylaterBookingStatus = true;
                        this.paylaterPopup.open();
                    }

                    else if (p == "Error") {
                        this.paylaterBookingStatus = false;
                    }
                },
                err => {
                    console.log("Error while getting data...");
                });
        }

        else {
            this.slotErrorMessage = "YES";
        }
    }

    PaylaterPopupClose() {
        this.paylaterPopup.close();
    }

    PaymentPopupProceed(radioPayment) {
        if (radioPayment != undefined) {
            if (radioPayment == 0) {
                this.generalBooking.PaymentTypeMode = "CREDIMAX";
                this.payCredimaxWithCreditCard();
            }
            //else {
            //    this.generalBooking.PaymentTypeMode = "BENEFIT";
            //}
            else if (radioPayment == 1) {
                this.generalBooking.PaymentTypeMode = "BENEFIT";
            }
            else {
                this.WalletradioClick();
                this.generalBooking.PaymentTypeMode = "MAXWALLET";
               // this.BSHMaxWalletQrCode(); 
            }
        }
        this.generalBooking.buttonActivity = "Payment";
        this.SaveAppointment();
    }

    BSHMaxWalletQrCode() {
        console.log(this.requestparamater);
        MaxWallet.open(this.requestparamater, this.successCallBack, this.errorCallBack, this.closeCallBack);
    }

    OnChangeCredit(radioPayment) {
        if (radioPayment != undefined) {
            if (radioPayment == 0) {
                this.generalBooking.PaymentTypeMode = "CREDIMAX";
                var userData: UserData = new UserData(this._SecurityService.pid, this._SecurityService.authentication, this._SecurityService.pid, this._SecurityService.IsAdminUser);

                this._bookingService.PaymentModeSelectionGuest(this.generalBooking, userData)
                    .subscribe(
                        p => {
                            this.loading = false;
                            if (p.length != 0) {
                                this.generalBooking.credimaxPaymentDetails = p.credimaxPaymentDetails;
                            }
                            else {

                            }
                        },
                        err => {
                            this.loading = false;
                            console.log("Error while getting department data...");
                        });
            }
            else {
                this.generalBooking.PaymentTypeMode = "BENEFIT";
            }
        }
    }
    payCredimaxWithCreditCard() {
        Checkout.configure({
            merchant: this.generalBooking.credimaxPaymentDetails[0].merchantId,
            order: {
                amount: this.generalBooking.credimaxPaymentDetails[0].amount,
                currency: this.generalBooking.credimaxPaymentDetails[0].currency,
                description: this.generalBooking.credimaxPaymentDetails[0].description,
                id: this.generalBooking.credimaxPaymentDetails[0].orderId
            },
            session: {
                id: this.generalBooking.credimaxPaymentDetails[0].sessionId
            },
            interaction: {
                merchant: {
                    name: this.generalBooking.credimaxPaymentDetails[0].name,
                    address: {
                        line1: 'Manama',
                        line2: 'Manama'
                    }
                }
            }
        });
        Checkout.showPaymentPage();
    }

    keyPress(event: any) {
        const pattern = /[0-9\ ]/;
        let inputChar = String.fromCharCode(event.charCode);
        if (event.keyCode != 8 && !pattern.test(inputChar)) {
            event.preventDefault();
        }
    }

    MobileNoChange1(event) {
        if (event.target.value.length > 8 || event.target.value.length != 8) {
            this.MobileNoValid1 = true;
        }
        else {
            this.MobileNoValid1 = false;
        }
    }

    CancelPatientPopup() {
        this.SlotCancel();
        this.IsDocumentAttached = false;
        this.appointmentBooking = false;
    }
    PaymentConfirm() {
        this.router.navigate(["/Booking"]);
    }
    PrintPreview() {
        this.PrintPreviewpopup.open();
    }

    openTermsCondition(Openval: number) {
        if (Openval == 1)
            this.IsEnglish = false;
        else
            this.IsEnglish = true;
        this.openTermConditions.open();
    }
    AlterBookCancel() {

        if (this.BookingType == "SLOT") {
            if (this.DoctorsSlotTiming != null && this.DoctorsSlotTiming != "" && this.DoctorsSlotTiming != undefined) {
            this.viewModelPopup.open();
                this.enableHadiPopup = "YES";
            }
            else {
                this.IsPatientValidFailed = true;
                this.IsPatientValid.open();
                this.message = "No available slot for the selected date. Choose another date";
            }
        }
            else {
                if (this.DoctorsSlotTiming != null && this.DoctorsSlotTiming != "" && this.DoctorsSlotTiming != undefined) {
                    this.viewModelPopup.open();
                    this.enableJnhPopup = "YES";
                }
                else {
                    this.IsPatientValidFailed = true;
                    this.IsPatientValid.open();
                    this.message = "No available Token for the selected date. Choose another date";
                }
        }
    }

    BookRequestCancel() {
        this.viewModelPopup.close();
        this.generalBooking.totalTimeSlots = [];
        this.DoctorsSlotTiming = "";
        this.generalBooking.SLOT = "";
        this.generalBooking.date = localStorage.getItem("MainDate");
        this.activebutton1 = Number(localStorage.getItem("MainDay"));
        this.generalBooking.dayCode = Number(localStorage.getItem("MainDay"));
        var ddd = localStorage.getItem("MainDate");
        var date_components = ddd.split("/");
        this.appDate1 = { date: { year: date_components[2], month: date_components[1], day: date_components[0] } };
        this.date = localStorage.getItem("MainDate");
        this.bookingFilter.FromDate = this.date;
    }

    makePdf() {
        const div = document.getElementById("Html2Pdf");
        const options = { height: div.clientHeight, width: div.clientWidth };
        html2canvas(div, options).then((canvas) => {
            const doc = new jspdf.jsPDF("p", "mm", "a4");
            const imgData = canvas.toDataURL("image/JPEG");
            doc.addImage(imgData, 'JPEG', 30, 30);
            const fileName = "Receipt.pdf";
            doc.save(fileName);
        });
    }

    UploadValidation() {
        this.IsuploadValidationErrorMsg = false;
        //this.UploadValidationErrorMsg = "";
        this.IsMOHImage = false;
        this.IsVisaImage = false;
        this.IsPassportFrontImage = false;
        this.IsPassportBackImage = false;
        this.IsCivilFrontImage = false;
        this.IsCivilBackImage = false;
        if (this.generalBooking.CivilIdFront != null && this.generalBooking.CivilIdFront != undefined) {
            if (this.generalBooking.CivilIdFront.fileName.match(/.(jpg|png|pdf)$/i)) {
                this.IsCivilFrontImage = false;
            }
            else {
                this.IsCivilFrontImage = true;
            }
        }
        if (this.generalBooking.CivilIdBack != null && this.generalBooking.CivilIdBack != undefined) {
            if (this.generalBooking.CivilIdBack.fileName.match(/.(jpg|png|pdf)$/i)) {
                this.IsCivilBackImage = false;
            }
            else {
                this.IsCivilBackImage = true;
            }
        }
        if (this.generalBooking.PassportBack != null && this.generalBooking.PassportBack != undefined) {
            if (this.generalBooking.PassportBack.fileName.match(/.(jpg|png|pdf)$/i)) {
                this.IsPassportBackImage = false;
            }
            else {
                this.IsPassportBackImage = true;
            }
        }
        if (this.generalBooking.PassportFront != null && this.generalBooking.PassportFront != undefined) {
            if (this.generalBooking.PassportFront.fileName.match(/.(jpg|png|pdf)$/i)) {
                this.IsPassportFrontImage = false;
            }
            else {
                this.IsPassportFrontImage = true;
            }
        }
        if (this.generalBooking.VisaAttach != null && this.generalBooking.VisaAttach != undefined) {
            if (this.generalBooking.VisaAttach.fileName.match(/.(jpg|png|pdf)$/i)) {
                this.IsVisaImage = false;
            }
            else {
                this.IsVisaImage = true;
            }
        }
        if (this.generalBooking.MOHAttach != null && this.generalBooking.MOHAttach != undefined) {
            if (this.generalBooking.MOHAttach.fileName.match(/.(jpg|png|pdf)$/i)) {
                this.IsMOHImage = false;
            }
            else {
                this.IsMOHImage = true;
            }
        }
        if (this.IsMOHImage == true || this.IsVisaImage == true || this.IsPassportFrontImage == true || this.IsPassportBackImage == true || this.IsCivilFrontImage == true || this.IsCivilBackImage == true) {
            this.IsuploadValidationErrorMsg = true;
            // this.UploadValidationErrorMsg = "Please Upload Only .jpg,.png and pdf format Files";
        }
        else {
            this.IsuploadValidationErrorMsg = false;
            // this.UploadValidationErrorMsg = "";
        }
    }

    public getFileDetails(isCivilInsurance, e) {
        this.fileList = [];
        this.theFile = null;
        this.message = "";
        this.errormessage = "";

        if (isCivilInsurance === 'isCivilFront') {
            this.generalBooking.CivilIdFront = null;
        }
        if (isCivilInsurance === 'isCivilBack') {
            this.generalBooking.CivilIdBack = null;
        }
        if (isCivilInsurance === 'isPassportFront') {
            this.generalBooking.PassportFront = null;
        }
        if (isCivilInsurance === 'isPassportBack') {
            this.generalBooking.PassportBack = null;
        }
        if (isCivilInsurance === 'isVisa') {
            this.generalBooking.VisaAttach = null;
        }
        if (isCivilInsurance === 'isMOH') {
            this.generalBooking.MOHAttach = null;
        }
        if (e.target.files && e.target.files.length > 0) {

            if (e.target.files[0].size < this.MAX_SIZE) {

                this.theFile = e.target.files[0];
                this.readAndUploadFile(this.theFile, isCivilInsurance);
                this.message = "";
                this.errormessage = "";
            }
            else {

                this.message = "";
                this.errormessage = "File: " + e.target.files[0].name + " is too large to upload.";

            }
        }
    }

    private readAndUploadFile(theFile: any, isCivilInsurance) {
        let file = new FileToUpload();

        file.PatientId = this.generalBooking.Id;
        file.fileName = theFile.name;
        file.fileSize = theFile.size;
        file.fileType = theFile.type;
        file.lastModifiedTime = theFile.lastModified;
        file.lastModifiedDate = theFile.lastModifiedDate;
        if (isCivilInsurance === 'isCivil') {
            file.PatientId = '0';
            if (this.BookingType == "TOKEN")
                file.FolderType = "ID";
            else
                file.FolderType = "CIVIL";
        }
        if (isCivilInsurance === 'isInsurance') {
            file.PatientId = '0';
            file.FolderType = "INSCARD";
        }
        if (isCivilInsurance === 'isCivilFront') {
            file.FolderType = "CIVIL";
        }
        if (isCivilInsurance === 'isCivilBack') {
            file.FolderType = "CIVIL";
        }
        if (isCivilInsurance === 'isPassportFront') {
            file.FolderType = "PASSPORT";
        }
        if (isCivilInsurance === 'isPassportBack') {
            file.FolderType = "PASSPORT";
        }
        if (isCivilInsurance === 'isVisa') {
            file.FolderType = "VISA";
        }
        if (isCivilInsurance === 'isMOH') {
            file.FolderType = "MOH";
        }
        let reader = new FileReader();


        reader.onload = () => {

            file.fileAsBase64 = reader.result.toString().split(',')[1].toString();
            if (isCivilInsurance === 'isCivil') {
                this.readCivilFile(file);
            }
            //else if (isCivilInsurance === 'isInsurance') {
            //    this.readInsuranceFile(file);
            //}

            if (isCivilInsurance === 'isCivilFront') {
                this.readCivilFrontFile(file);
            }
            if (isCivilInsurance === 'isCivilBack') {
                this.readCivilBackFile(file);
            }
            if (isCivilInsurance === 'isPassportFront') {
                this.readPassportFrontFile(file);
            }
            if (isCivilInsurance === 'isPassportBack') {
                this.readPassportBackFile(file);
            }
            if (isCivilInsurance === 'isVisa') {
                this.readVisaFile(file);
            }
            if (isCivilInsurance === 'isMOH') {
                this.readMOHFile(file);
            }
        }

        reader.readAsDataURL(theFile);
    }

    readCivilFile(file) {
        this.IsReqCivil = false;
        this.IsCivilRed = false;
        this.generalBooking.CivilIdDoc = file;

    }

    //readInsuranceFile(file) {
    //    this.IsReqInsurance = false;
    //    this.generalBooking.InsuredIdDoc = file;

    //}
    readMOHFile(file) {
        this.generalBooking.MOHAttach = file;
    }
    readCivilFrontFile(file) {
        this.generalBooking.CivilIdFront = file;
    }
    readCivilBackFile(file) {
        this.generalBooking.CivilIdBack = file;
    }
    readPassportFrontFile(file) {
        this.generalBooking.PassportFront = file;
    }
    readPassportBackFile(file) {
        this.generalBooking.PassportBack = file;
    }
    readVisaFile(file) {
        this.generalBooking.VisaAttach = file;
    }


    LoadLocation() {
        var userData: UserData = new UserData(this._SecurityService.pid, this._SecurityService.authentication, this._SecurityService.pid, this._SecurityService.IsAdminUser);
        this.loading = true;
        this._bookingService.getLocationGuest(userData)
            .subscribe(
                p => {
                    if (p != null) {
                        this.Locs = p.Locations;
                        if (p.DefaultLocation != null)
                            this.generalBooking.LocationId = p.DefaultLocation;
                    }
                },
                err => {
                    this.loading = false;
                    console.log("Error while getting department data...");
                });
    }
    OnLocationChange() {
        this.IsLocationChange = true;
        this.LoadDepartments();
        this.LoadFilterReports();
        this.IsLocationChange = false;
    }

    successCallBack = (result: responseParam): void => {
        console.log(result);
        //this.generalBooking.AppointmentRquestNo = this.generalBooking.ScheduleAppNo;

        if (result.errorCode == "200") { this.generalBooking.CaptureData = "CAPTURED"; }
        this.LoadingAfterPayment("");

    }
    errorCallBack = (result: responseParam): void => {
        console.log(result);
        if (result.errorCode == "400") { this.generalBooking.CaptureData = "NOTCAPTURE"; }
        if (result.errorCode == "401") { this.generalBooking.CaptureData = "NOTCAPTURE"; }
        if (result.errorCode == "403") { this.generalBooking.CaptureData = "NOTCAPTURE"; }
        if (result.errorCode == "404") { this.generalBooking.CaptureData = "NOTCAPTURE"; }
        if (result.errorCode == "412") { this.generalBooking.CaptureData = "NOTCAPTURE"; }
        if (result.errorCode == "500") { this.generalBooking.CaptureData = ""; }
        if (result.errorCode == "503") { this.generalBooking.CaptureData = ""; }
        this.LoadingAfterPayment("");

    }
    closeCallBack = (result: responseParam): void => {
        console.log(this.requestparamater);
        this.router.navigate(["/GuestAppointment"]);
    }
    WalletradioClick() {
        //var rere = this.generalBooking.requestParam;
        var secure_hash = this.generalBooking.requestParam[0].hashedString;
        var secretKey = this.generalBooking.requestParam[0].secretKey;

        this.requestparamater.merchantId = this.generalBooking.requestParam[0].merchantId;//"03477850"; 
        this.requestparamater.transactionAmount = this.generalBooking.requestParam[0].transactionAmount;
        this.requestparamater.transactionCurrency = this.generalBooking.requestParam[0].transactionCurrency;//"BHD";
        this.requestparamater.hashedString = secure_hash;
        this.requestparamater.appId = this.generalBooking.requestParam[0].appId;//"3776553556"; 
        this.requestparamater.referenceNumber = this.generalBooking.requestParam[0].referenceNumber;
        this.requestparamater.secure_hash = this.generalBooking.requestParam[0].secure_hash; // CryptoJS.enc.Base64.stringify(CryptoJS.HmacSHA256(secure_hash, secretKey));
        this.requestparamater.paymentType = this.generalBooking.requestParam[0].paymentType;
        this.requestparamater.showResult = this.generalBooking.requestParam[0].showResult;
        this.requestparamater.lang = this.generalBooking.requestParam[0].lang;
    }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./app/booking/Component/Booking.Component.ts